// Solano Essence i18n — en
const en = {
  "webGate": {
    "title": "Please use the iPhone app",
    "body": "Solano Essence lives exclusively in the iPhone app. Open the app on your phone to continue — your coach is waiting for you there."
  },
  "engagement": {
    "title": "Client engagement",
    "filterAll": "All",
    "filterRed": "Inactive",
    "filterAmber": "Fading",
    "filterGreen": "Active",
    "statusActive": "Active",
    "statusFading": "Fading",
    "statusInactive": "Inactive",
    "lastActive": "Last active",
    "today": "Today",
    "yesterday": "Yesterday",
    "daysAgo": "days ago",
    "never": "Never active",
    "emptyFilter": "No clients in this category"
  },
  "common": {
    "edit": "Edit",
    "networkError": "Server unreachable. Please check your internet connection and try again.",
    "save": "Save",
    "saved": "Saved ✓",
    "cancel": "Cancel",
    "back": "Back",
    "loading": "Loading…",
    "daysAgoShort": "{n}d ago",
    "error": "Error",
    "saving": "Saving…",
    "none": "—",
    "delete": "Delete",
    "add": "Add",
    "ok": "OK",
    "done": "Done",
    "clear": "Clear",
    "close": "Close",
    "search": "Search",
    "all": "All",
    "kg": "kg",
    "kcal": "kcal",
    "protein": "Protein",
    "carbs": "Carbs",
    "fat": "Fat",
    "calories": "Calories",
    "date": "Date",
    "time": "Time",
    "notes": "Notes",
    "logout": "Log out",
    "select": "Select",
    "confirm": "Confirm",
    "reject": "Reject",
    "completed": "Completed",
    "welcomeBack": "Welcome back",
    "retry": "Retry",
    "gotIt": "Got it",
    "refresh": "Refresh",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Sun",
    "copied": "copied",
    "copy": "Copy",
    "dismiss": "Dismiss",
    "errorGeneric": "Something went wrong.",
    "micDenied": "Microphone permission denied",
    "micUnsupported": "Microphone not supported on this device",
    "more": "More",
    "next": "Next",
    "prev": "Back",
    "recipe": "Recipe",
    "remove": "Remove",
    "stop": "Stop",
    "undo": "Undo"
  },
  "appStats": {
    "title": "App statistics",
    "subtitle": "Overview of your practice",
    "scopeNote": "These numbers cover ONLY your clients and your practice.",
    "orphanNote": "Note: {n} unlinked client accounts exist in the system (test / open invites).",
    "myClients": "My clients",
    "coaches": "Coaches in studio",
    "users": "Users",
    "engagement": "Engagement",
    "aiUsage": "AI usage",
    "notifSocial": "Push & community",
    "growthTrend": "Growth trend",
    "totalClients": "Clients",
    "nutritionists": "Nutritionists",
    "activeToday": "Active today",
    "newUsersWeek": "New · 7 days",
    "thisWeek": "this week",
    "pastWeek": "past 7 days",
    "total": "total",
    "mealsToday": "Meals today",
    "workoutsToday": "Workouts today",
    "waterToday": "Water logs today",
    "sharedMealsWeek": "Shared meals · 7d",
    "coachMsgsToday": "Coach AI · today",
    "weeklyMenusWeek": "Weekly menus · 7d",
    "recipeImagesCached": "Recipe image cache",
    "foodsAiCached": "AI foods cache",
    "pushSubs": "Push subscribers",
    "notifToday": "Pushes today",
    "chatWeek": "Chat msgs · 7d",
    "upcomingAppts": "Upcoming appts"
  },
  "quickSteps": {
    "title": "Steps today",
    "subtitle": "Type the number from your step-tracking app",
    "saved": "Steps saved",
    "invalid": "Invalid number"
  },
  "wearable": {
    "directIntegrations": "Direct wearable integrations",
    "appleBridgeHint": "Syncs supported data from Apple Watch and connected apps and devices such as Garmin, Fitbit, Polar and smart scales.",
    "directSoonTitle": "Direct connections – coming soon",
    "directSoonHint": "Basic data from these providers may already sync via Apple Health. Direct connections will later add extra, provider-specific metrics.",
    "connected": "Connected",
    "notConnected": "Not connected",
    "paused": "Paused",
    "comingSoon": "Coming soon",
    "manualOnly": "Manual import only",
    "connectCta": "Connect",
    "needsCreds": "Server credentials missing — coming soon",
    "applePlaceholder": "WHOOP doesn't return step count via API. For accurate Steps, Weight and Calories: connect Apple Health through the iOS app \"Health Auto Export\" — generate a token below, paste it into the app.",
    "healthkitCta": "Sync directly from HealthKit",
    "healthkitSyncing": "Reading HealthKit…",
    "healthkitDone": "HealthKit sync done: {days} days",
    "healthkitDenied": "HealthKit access failed. Check permissions in Settings → Health → Data Access.",
    "healthkitServerError": "Server error while saving your health data. Please try again later.",
    "healthkitNetworkError": "No connection to the server. Check your internet connection.",
    "healthkitHint": "This app can read Health data directly from your iPhone — no extra app needed.",
    "healthConnectSoon": "Health Connect integration for Android is coming soon. Until then you can connect WHOOP, Garmin & co. directly.",
    "healthConnectBridgeHint": "Reads steps, calories, sleep, resting heart rate, HRV, weight and workouts from Health Connect – i.e. from Samsung Health, Fitbit, Garmin, Google Fit & co.",
    "healthConnectDone": "Health Connect sync done: {days} days",
    "healthConnectCta": "Sync directly from Health Connect",
    "healthConnectSyncing": "Reading Health Connect…",
    "healthConnectDenied": "Health Connect access not possible. Open the Health Connect app → App permissions → Solano Essence and allow reading.",
    "healthConnectMissing": "Health Connect is not installed or outdated on this device. Please install/update it from the Play Store.",
    "healthConnectEmpty": "Permission OK, but Health Connect holds no data for the last 7 days. Enable syncing to Health Connect in your fitness app (Samsung Health → Settings → Health Connect, Fitbit, Garmin Connect, Google Fit …) and try again.",
    "healthConnectNoPermission": "No Health Connect permission granted. Open Health Connect → App permissions → Solano Essence and allow reading steps, calories, sleep, heart rate and weight.",
    "healthConnectOpen": "Open Health Connect",
    "healthConnectSoonShort": "Soon via Health Connect",
    "myDevices": "My devices",
    "addDevice": "Add device",
    "noDevices": "No device connected yet.",
    "active": "Active",
    "available": "Available",
    "iosOnly": "In the Solano app (iPhone/Android)",
    "pause": "Pause",
    "resume": "Resume",
    "syncNow": "Sync now",
    "syncing": "Sync…",
    "disconnect": "Disconnect",
    "disconnectedOk": "Disconnected",
    "lastSync": "Last sync",
    "priorityRule": "Data priority on duplicates",
    "whoopConnectedOk": "WHOOP connected — starting first sync…",
    "syncedOk": "Sync done: {days} days",
    "resumedOk": "Sync resumed",
    "pausedOk": "Sync paused",
    "manualTag": "Without wearable",
    "manualTitle": "Enter values manually",
    "manualDate": "Date",
    "manualSleepMin": "Sleep (min)",
    "manualRestingHr": "Resting HR (bpm)",
    "manualHrv": "HRV (ms)",
    "manualSteps": "Steps",
    "manualActiveKcal": "Active kcal",
    "manualRecovery": "Recovery (0-100)",
    "manualSaveCta": "Save values",
    "manualSavedOk": "Values saved",
    "manualEmpty": "Enter at least one value",
    "manualRecent": "Recent entries",
    "whoopNoSteps": "WHOOP doesn't sync step count via API. Connect Apple Health below to get accurate Steps, Weight and Calories automatically.",
    "appleSyncHint": "Apple Health pushes data automatically from your iPhone. Open the \"Health Auto Export\" app → tap \"Run Now\" — Steps, Weight and Calories arrive in ~20 seconds.",
    "appleWaiting": "Waiting for iPhone",
    "appleTestWebhook": "Test webhook",
    "appleTestOk": "Test payload received ✓",
    "appleTestFail": "Test failed",
    "appleSetupOpen": "Setup / Automatic import",
    "appleSetupClose": "Close setup",
    "appleResetToday": "Reset today",
    "appleResetConfirm": "Clear Apple values for today? If Health Auto Export sends new data later, it will overwrite.",
    "appleResetOk": "Today's values cleared",
    "appleAutoHint": "Syncs automatically from your iPhone in the background. For an instant refresh: open \"Health Auto Export\" → Run Now.",
    "appleHeaderAlt": "Alternative: header instead of URL token",
    "appleHeaderAltHint": "Use EITHER the URL with ?token above OR these three fields (URL + Key + Value) under \"Add headers\" — not both.",
    "appleBridgeTag": "Health Auto Export Bridge",
    "appleBridgeSetup": "Set up automatic import",
    "appleBridgeConnected": "Apple Health connected",
    "appleStep1": "Install the \"Health Auto Export\" app on your iPhone (Free)",
    "appleStep2": "Open the app → \"Automations\" → \"+ Add Automation\" → \"REST API\"",
    "appleStep3": "Paste the URL below → select: Steps, Weight, Active Energy, Resting HR, Sleep, HRV, Workouts",
    "appleStep4": "Save and tap \"Run Now\" — data arrives in ~20 seconds",
    "appleGenerateToken": "Generate token",
    "appleWebhookUrl": "Webhook URL (paste into Health Auto Export)",
    "appleTokenCreated": "New token generated",
    "appleTokenRevoked": "Token deleted",
    "appleTokenCreatedAt": "Created",
    "appleLastPayload": "Last import",
    "appleRotateToken": "Rotate",
    "appleRevokeToken": "Delete",
    "appleRevokeConfirm": "Delete this token? The iPhone app will stop sending data.",
    "metric": {
      "steps": "Steps",
      "weight_kg": "Weight",
      "active_calories": "Active kcal",
      "hr": "Heart rate",
      "resting_hr": "Resting HR",
      "sleep": "Sleep",
      "workouts": "Workouts",
      "recovery": "Recovery",
      "hrv": "HRV",
      "strain": "Strain"
    }
  },
  "health": {
    "title": "Health Score",
    "chipLabel": "Health",
    "chipEmpty": "No meals",
    "excellent": "Excellent",
    "veryGood": "Very good",
    "good": "Good",
    "fair": "Can improve",
    "poor": "Needs attention",
    "noMeals": "Log meals to get your score",
    "hint": "Based on protein, fibre, fruit & veg, sat fat, sugars, salt and water.",
    "muscleTitle": "Muscle",
    "heartTitle": "Heart",
    "energyTitle": "Energy",
    "saltPinch": "a pinch of salt",
    "saltHalfTsp": "½ teaspoon of salt",
    "saltTsp": "teaspoon of salt",
    "saltTspPl": "teaspoons of salt",
    "infoAria": "How the Health Score works",
    "infoTag": "How it works",
    "infoTitle": "Your Health Score",
    "infoBody": "The score is calculated on today's logged meals. It sums positive points for good habits and subtracts penalties for components to limit. Maximum 100.",
    "infoPositiveTitle": "Bonus (max 70)",
    "infoProtein": "Protein (~1.4 g/kg body weight)",
    "infoFiber": "Fibre (30 g/day)",
    "infoFV": "Fruit & vegetables (4 portions)",
    "infoWater": "Water (2 L)",
    "infoNegativeTitle": "Penalties (max 30)",
    "infoSatFat": "Saturated fat (<10% kcal)",
    "infoSugar": "Sugar (<40 g)",
    "infoSalt": "Salt (<5 g)",
    "infoNegativeHint": "Full points when well below threshold, zero when well above.",
    "infoTip": "Tap the HEALTH ring in the top bar to see today's live breakdown.",
    "infoSource": "Sources: WHO, EFSA, Italian ISS/CREA nutrition guidelines 2018.",
    "infoSubTitle": "The 3 rings explained",
    "infoMuscleDesc": "60% protein (share of your daily target) + 25% workout (20 min = 100%) + 15% calorie adequacy (close to target = full points, too much or too little lowers it).",
    "infoHeartDesc": "30% fibre + 30% fruit & veg (4 servings = 100%) + 20% salt + 20% saturated fat. For salt & fat: below the limit = 100%, above it the value drops.",
    "infoEnergyDesc": "40% water + 30% carbs + 30% activity. Activity = the best of steps (share of your step goal) OR workout (30 min = 100%) — a workout counts in full even with few steps."
  },
  "streak": {
    "dayOne": "day",
    "dayMany": "days",
    "tooltip": "Consecutive days ≥ {target} steps · Best: {best}"
  },
  "nutriscore": {
    "info": {
      "title": "What is Nutri-Score?",
      "body": "Nutri-Score is an orientation aid: it compares similar products with each other. It doesn't say by itself whether a food is healthy or unhealthy.",
      "hint": "A = more balanced nutrition per 100g. E = intense ingredients such as sugar, salt or saturated fat."
    }
  },
  "solano": {
    "label": "Solano rating",
    "tier": {
      "very_good": "Very good choice",
      "good": "Good choice",
      "ok": "OK",
      "mindful": "Enjoy mindfully"
    },
    "hint": {
      "bio": "Organic quality",
      "wholegrain": "Whole grain",
      "no_added_sugar": "No added sugar",
      "less_fat": "Less fat than classic",
      "fried": "Fried — use sparingly",
      "processed_meat": "Processed meat — mindful",
      "whole_food": "Whole food",
      "mindful": "Only occasionally",
      "watch_salt": "Watch salt and saturated fat",
      "hydrating": "Great for hydrating"
    }
  },
  "nutAdvice": {
    "title": "Nutrition Coach",
    "chipLabel": "Nutrition",
    "subtitle": "{count} concrete tips for the rest of the day",
    "noData": "Log meals to get personalised tips"
  },
  "challenges": {
    "title": "Today's challenges",
    "chipLabel": "Challenges",
    "subtitle": "{done}/{total} done today",
    "allDone": "All challenges done today! 🎉",
    "startCta": "Start tracking to unlock the challenges",
    "hint": "Resets every day. Keep the streak going!",
    "completed": "Completed",
    "remaining": "to go",
    "edit": "Customize",
    "editTitle": "Customize your challenges",
    "editDesc": "Set daily targets and disable the ones you don't want to track.",
    "steps": "Steps",
    "fiber": "Fibre",
    "protein": "Protein",
    "water": "Water",
    "waterQuickTitle": "Add water",
    "waterCustomPlaceholder": "Enter ml…",
    "saveBtn": "Save challenges",
    "saved": "Challenges updated!",
    "resetDefaults": "Reset to defaults",
    "atLeastOne": "At least one challenge must remain active"
  },
  "learn": {
    "title": "Learn",
    "chipLabel": "Learn",
    "chipNew": "New article",
    "subtitle": "Today's pill",
    "next": "Next pill",
    "loading": "Picking a pill for you…",
    "empty": "No pill available",
    "catNutrition": "Nutrition",
    "catBasics": "Basics",
    "basicsProgress": "Basics curriculum · Lesson {n} of {total}",
    "quizTitle": "Quick quiz",
    "quizCorrect": "Correct!",
    "quizCorrectSp": "Correct! +{points} Solano Points",
    "quizWrong": "Not quite — the correct answer is highlighted.",
    "catHealth": "Health",
    "catRecipes": "Recipes",
    "catMyths": "Myths busted",
    "pickCategory": "Change topic",
    "limitReached": "You've seen all today's pills — come back tomorrow!",
    "statsTitle": "Your learning week",
    "weekCorrect": "{correct}/{answered} correct",
    "streak": "{n}-day learning streak",
    "streakNone": "Start your learning streak today",
    "streakNext": "Bonus from {n} days",
    "streakBonusToday": "+{points} bonus today",
    "streakBonus": "{n}-day streak: +{points} Solano Points bonus!",
    "reviewTitle": "Review",
    "reviewDue": "{n} due",
    "reviewStart": "Knowledge check: revisit an old card",
    "reviewHint": "Card from {days} days ago — does it still stick?",
    "reviewNone": "No review due — keep it up!",
    "reviewCorrect": "It stuck! +{points} Solano Points",
    "reviewWrong": "Not quite — remember the highlighted answer.",
    "reviewNext": "Next review ({n})"
  },
  "med": {
    "title": "Mediterranean Score",
    "chipLabel": "Med",
    "chipDays": "Last {days}d",
    "chipEmpty": "Log meals",
    "subtitle": "Last {days} days",
    "hint": "Adherence to the Mediterranean diet: more olive oil, fish, vegetables, legumes, whole grains and nuts; less red meat.",
    "noData": "Log meals over the last 7 days",
    "infoAria": "How the score works",
    "infoTag": "How it works",
    "infoTitle": "Your Mediterranean Score",
    "infoBody": "We analyse the last 7 days of your food diary and detect 8 key Mediterranean food groups (plus a red-meat penalty). Each meal is classified by its ingredients; if you also include grams (e.g. \"80g spinach\"), we compute real portions following CREA/EFSA guidelines.",
    "infoTargetsTitle": "Weekly targets · portion",
    "infoTip": "Tip: include grams in your meals (e.g. \"150g beans\") for a more accurate count. Without grams, each meal counts as 1 portion.",
    "infoSource": "Source: MedDiet Adherence Score (Trichopoulou 2003, PREDIMED), CREA/EFSA portion guidelines.",
    "penaltyHint": "Each portion above 1/week deducts points (max −6).",
    "tipTitle": "Today's tip",
    "tipCta": "See matching recipes",
    "genEmpty": "No matching recipe in your library",
    "genBtn": "Generate a new recipe with AI",
    "tips": {
      "olive_oil": "Add a tablespoon of olive oil today – e.g. over veggies or in a salad.",
      "fish": "Plan a portion of fish today or tomorrow – e.g. salmon, trout or tuna.",
      "vegetables": "One extra portion of vegetables today – e.g. salad, broccoli or roasted veggies.",
      "fruits": "Grab one more piece of fruit today – e.g. an apple, berries or a banana.",
      "legumes": "One portion of legumes today – e.g. lentils, chickpeas or beans.",
      "whole_grains": "Go wholegrain today – e.g. oats, wholegrain bread or brown rice.",
      "nuts_seeds": "A small handful of nuts or seeds as a snack – e.g. almonds or walnuts.",
      "dairy_fermented": "Have a yogurt, skyr or kefir today – great as a snack or at breakfast.",
      "red_meat": "A lot of red meat this week – swap today for fish, poultry or legumes.",
      "processed_meat": "Cut down on cured meats – try hummus, cheese or avocado today."
    }
  },
  "moderation": {
    "newReportToast": "New report ({reason}) about {name}",
    "openReports": "{n} open reports",
    "report": "Report",
    "block": "Block",
    "unblock": "Unblock",
    "reportTitle": "Report {name}",
    "reason_harassment": "Harassment",
    "reason_spam": "Spam",
    "reason_inappropriate": "Inappropriate content",
    "reason_other": "Other",
    "reportTextPh": "Optional: what happened?",
    "reportHint": "Your report goes confidentially to the Solano team and is reviewed within 24 h.",
    "reportSubmit": "Send report",
    "reportSent": "Thank you – your report has been submitted.",
    "blockConfirm": "Block {name}? You will no longer see each other; messages and friend requests (also via code) are no longer possible.",
    "blockedOk": "{name} has been blocked.",
    "unblockedOk": "Unblocked.",
    "sendBlocked": "Message not possible – this contact is blocked.",
    "blockedTitle": "Blocked users",
    "blockedHint": "Blocked people cannot send you messages or requests.",
    "blockedEmpty": "You haven't blocked anyone.",
    "filter_open": "Open",
    "filter_resolved": "Resolved",
    "filter_all": "All",
    "noReports": "No reports.",
    "reportedUser": "Reported",
    "reporter": "Reported by",
    "userBlocked": "blocked",
    "messageDeleted": "message deleted",
    "deleteMessage": "Delete message",
    "blockUser": "Block user",
    "blockConfirmAdmin": "Block this user? All sessions will be terminated.",
    "resolve": "Resolve",
    "deletedOk": "Message deleted.",
    "userBlockedOk": "User blocked.",
    "resolvedOk": "Report resolved."
  },
  "friends": {
    "remove": "Remove friend",
    "photoCamera": "Take a photo",
    "photoFile": "Send image from gallery/file",
    "shareTitle": "Share",
    "shareTabMeals": "Meals",
    "shareTabRecipes": "Recipes",
    "shareRecipeHint": "Pick a saved recipe – it is sent to the chat as a card with nutrition facts.",
    "shareRecipeEmpty": "No recipes found.",
    "searchRecipes": "Search recipes…",
    "recipeShared": "Recipe",
    "openRecipe": "Open recipe",
    "perServing": "per serving",
    "shareMeal": "Share a meal",
    "shareMealTitle": "Share a meal",
    "shareMealHint": "Pick a logged meal – it is sent to the chat with photo and nutrition facts.",
    "shareMealEmpty": "No meals logged yet.",
    "mealShared": "Meal",
    "removeConfirm": "Remove this friend? The chat stays hidden until you reconnect.",
    "openChat": "Open",
    "toastGoToChat": "Tap to open the chat",
    "chatEmpty": "…",
    "pageTitle": "Friends",
    "pageSubtitle": "Find friends, motivate each other",
    "requestsInbox": "Incoming requests",
    "addSection": "Add friends",
    "yourFriends": "Your friends",
    "leaderboardTitle": "Weekly leaderboard",
    "leaderboardHint": "Average Health Score over the last 7 days",
    "computingBoard": "Computing leaderboard…",
    "boardEmpty": "No friends on the leaderboard yet.",
    "boardEmptyHint": "Add friends to compare every week.",
    "daysActive": "{n} active days",
    "noDayTracked": "No day tracked",
    "you": "You",
    "yourCode": "Your code",
    "copy": "Copy",
    "regenerate": "Regenerate",
    "shareHint": "Share this code with a friend via WhatsApp. They enter it in their app and you become friends.",
    "shareWa": "Share on WhatsApp",
    "hasCodeQ": "Have a friend's code?",
    "redeemBtn": "Add",
    "codeInvalid": "The code must be 6 characters",
    "alreadyFriends": "You are already friends",
    "codeNotValid": "Invalid code",
    "copyOk": "Code copied",
    "copyErr": "Unable to copy",
    "newCodeGen": "New code generated",
    "genericError": "Error",
    "waMessage": "Hi! Add me on Solano Essence with my code: {code}\nGet the app: https://solano-essence.com",
    "chatMsgPlaceholder": "Write a message…",
    "removeFriend": "Remove friend",
    "confirmRemove": "Are you sure you want to remove this friend?",
    "removedOk": "Friend removed",
    "accept": "Accept",
    "decline": "Decline",
    "noChange": "No change",
    "pushBannerTitle": "Turn on notifications",
    "pushBannerHint": "Get an alert even when the app is closed when a friend messages you",
    "pushBannerCta": "Turn on",
    "pushToastOk": "Notifications on!",
    "emptyList": "No friends yet. Search above to add someone.",
    "confirmRegen": "Regenerating the code will invalidate the old one. Continue?"
  },
  "mealType": {
    "colazione": "Breakfast",
    "spuntino": "Snack",
    "pranzo": "Lunch",
    "merenda": "Afternoon",
    "cena": "Dinner",
    "altro": "Other"
  },
  "exlib": {
    "ctaBtn": "Build a workout",
    "ctaHint": "Pick exercises from the library, load a template or train live",
    "title": "Exercise library",
    "subtitle": "870+ exercises with images – strength, cardio, stretching",
    "tabSearch": "Exercises",
    "tabTemplates": "Templates",
    "tabPlan": "My plan",
    "searchPlaceholder": "Search exercise or muscle…",
    "all": "All",
    "results": "{n} exercises",
    "exercises": "exercises",
    "loadingInstructions": "Loading instructions…",
    "addToPlan": "Add to workout",
    "inPlan": "In plan",
    "planEmpty": "No exercises yet – pick some from search or load a template.",
    "sets": "Sets",
    "reps": "Reps",
    "repsShort": "reps",
    "seconds": "Sec",
    "useTime": "By time",
    "useReps": "By reps",
    "saveDone": "Save as done",
    "startLive": "Start now",
    "customWorkout": "My workout",
    "setsDone": "{done} of {total} sets",
    "rest": "Rest",
    "finish": "Finish workout",
    "abortConfirm": "Abort workout? Ticked sets will be lost.",
    "saved": "Workout saved – {min} min, strong!",
    "liveNote": "Live workout: {done}/{total} sets",
    "savedPlan": "Workout saved",
    "lastTime": "Last time: {w} kg × {r} ({d})",
    "lastTimeReps": "Last time: {r} reps ({d})",
    "best": "Best {w} kg",
    "newRecord": "New record!",
    "saveTemplate": "Save as template",
    "templateName": "Template name",
    "templateSaved": "Template saved",
    "myTemplates": "My templates",
    "fromCoach": "From coach",
    "deleteTemplateConfirm": "Delete this plan?",
    "myPlansTitle": "My workout plans",
    "myPlansHint": "Tap to start right away",
    "assignToClient": "Assign to client",
    "assigned": "Plan assigned",
    "coachPlansTitle": "Workout plans",
    "coachPlansEmpty": "No plan assigned yet – build one from the exercise library.",
    "assignBtn": "Assign plan",
    "editPlan": "Edit plan",
    "saveChanges": "Save changes",
    "changesSaved": "Plan updated",
    "daysLabel": "Days",
    "todayDue": "Today",
    "todaySuggest": "On today: {name}",
    "historyTitle": "Live workouts & records",
    "historyEmpty": "No workouts with exercises logged yet.",
    "curveTitle": "Max weight – last {weeks} weeks",
    "curveEmpty": "Not enough data for a curve yet – from the second workout with weight.",
    "suggestWeight": "All sets hit last time – suggested {w} kg (+2.5)",
    "keepLast": "Keep {w} kg",
    "weekTitle": "Your weekly review",
    "weekWorkouts": "Workouts",
    "weekMinutes": "Minutes",
    "weekVolume": "Volume",
    "weekRecords": "Records",
    "weekVolumeHint": "You moved {kg} kg this week – sets × reps × weight. Strong!",
    "weekHint": "Log weights in your next workout to see your volume here.",
    "weekShare": "Share review",
    "weekNewRecords": "New records",
    "weekShareNoRecords": "Keep going – next week a record will fall!",
    "weekShareFooter": "Trained with Solano Essence",
    "weekShareDownloaded": "Image saved",
    "deloadHint": "{n} weeks up in a row – go lighter this week: {w} kg (−10 %)",
    "deloadApply": "Apply",
    "deloadTitle": "Deload week recommended",
    "deloadBody": "{names}: up {n} weeks in a row. Train at −10 % this week – your body recovers and you come back stronger.",
    "swapTitle": "Machine busy? Same-muscle alternative",
    "swapEmpty": "No suitable alternative found.",
    "swapped": "Swapped for {name}",
    "photoStart": "Start",
    "photoEnd": "End",
    "openDetail": "View exercise",
    "placeGym": "Gym",
    "placeHome": "Home",
    "showAll": "Show all",
    "showCore": "Classics only",
    "pickGroup": "What do you want to train?",
    "coreCount": "{n} classics",
    "resultsCore": "{n} classics · {all} total",
    "moreAll": "Show {n} more exercises",
    "empty": "Nothing found – try another term.",
    "coreBadge": "Classic",
    "guideLoading": "Loading coach tips…",
    "steps": "How to",
    "tips": "Technique tips",
    "mistakes": "Common mistakes",
    "breathing": "Breathing",
    "feel": "Where you feel it",
    "easier": "Easier",
    "harder": "Harder",
    "showPhotos": "Show original photos",
    "hidePhotos": "Hide photos",
    "regenImage": "Wrong pose? Redraw",
    "regenDone": "Mascot redrawn",
    "regenRecent": "Already redrawn in the last 24 h",
    "regenBudget": "AI budget for today used up – try again later",
    "group": {
      "chest": "Chest",
      "back": "Back",
      "legs": "Legs & glutes",
      "shoulders": "Shoulders",
      "arms": "Arms",
      "core": "Abs & core",
      "cardio": "Cardio & full body",
      "stretch": "Mobility & stretching"
    }
  },
  "recipePhoto": {
    "title": "Change recipe image",
    "menu": "Change photo",
    "takePhoto": "Take photo",
    "fromGallery": "Choose from gallery",
    "aiHint": "AI creates a matching food photo from name and ingredients",
    "remove": "Remove photo",
    "updated": "Recipe image updated",
    "removed": "Recipe image removed",
    "cropTitle": "Crop image",
    "cropHint": "Drag to move, pinch to zoom, arrows to rotate",
    "cropApply": "Crop & save",
    "styleTitle": "Style for the AI photo",
    "styleRustic": "Rustic",
    "styleBright": "Bright & modern",
    "styleTopdown": "Top-down",
    "generateNow": "Generate now",
    "variantsBtn": "Generate 2 proposals",
    "variantsGenerating": "Creating two proposals…",
    "pickTitle": "Which one do you like more?",
    "pickHint": "Tap the better photo and apply it.",
    "variantsRetry": "Try again",
    "variantApply": "Use this one"
  },
  "recipeScan": {
    "addPage": "Add page / back side",
    "photosCount": "{n} photo(s) selected",
    "readBtn": "Read recipe",
    "removePhoto": "Remove photo",
    "or": "or",
    "urlLabel": "Paste a recipe link",
    "urlPlaceholder": "https://…/recipe",
    "urlBtn": "Import",
    "urlReading": "Reading web page…",
    "urlError": "Page could not be loaded – check the link or photograph a screenshot.",
    "invalidUrl": "Please enter a valid link.",
    "ctaBtn": "Photograph a recipe",
    "title": "Recipe from photo",
    "subtitle": "Take a photo of a cookbook page or recipe card – AI turns it into a Solano recipe.",
    "takePhoto": "Take photo",
    "fromGallery": "From gallery",
    "tip": "Tip: lay the page flat in good light; ingredients and steps should be readable.",
    "scanning": "Reading recipe…",
    "scanningHint": "Detecting ingredients, amounts and steps, then computing nutrition.",
    "reviewTitle": "Review recipe",
    "reviewDesc": "Check name, amounts and steps – then save.",
    "nameLabel": "Name",
    "servingsLabel": "Servings",
    "ingredientsLabel": "Ingredients (one per line)",
    "stepsLabel": "Method (one step per line)",
    "filledNote": "{n} ingredient(s) without an amount were filled with typical amounts – please check.",
    "usePhoto": "Use photo as recipe image",
    "fromSource": "Source: {title}",
    "lowConfidence": "The page was hard to read – please double-check ingredients and amounts.",
    "save": "Save as recipe",
    "saved": "Recipe “{name}” saved",
    "retake": "Another photo",
    "noRecipe": "No recipe found in the photo – please photograph a page with ingredients and method.",
    "error": "Could not read the recipe – please try again."
  },
  "fridge": {
    "ctaBtn": "Cook from fridge",
    "title": "What's in your fridge?",
    "subtitle": "List the ingredients you have and AI will build a full recipe with macros and nutrients.",
    "ingredientsLabel": "Your ingredients",
    "ingredientsPlaceholder": "e.g. 2 eggs, 200g tomatoes, mozzarella, rice, basil, olive oil",
    "ingredientsHint": "Separate by comma. Salt, pepper, water and oil are assumed to be available.",
    "photoBtn": "Fridge photo",
    "recognizing": "Scanning…",
    "photoDetected": "Added {count} ingredients from the photo",
    "photoRecogError": "Couldn't recognize ingredients, please retry",
    "mealTypeLabel": "Meal type (optional)",
    "maxTimeLabel": "Max time (min)",
    "servingsLabel": "Servings",
    "goalLabel": "For which goal?",
    "goalAny": "None",
    "goalHint.weight_loss": "≈ 350-500 kcal · ≥ 20 g protein per serving",
    "goalHint.maintenance": "≈ 450-650 kcal · balanced macros",
    "goalHint.muscle_gain": "≈ 600-800 kcal · ≥ 35 g protein per serving",
    "dietaryLabel": "Preferences (optional)",
    "dietVeg": "Vegetarian",
    "dietVegan": "Vegan",
    "dietGlutenFree": "Gluten-free",
    "dietLactoseFree": "Lactose-free",
    "dietLowCarb": "Low carb",
    "dietHighProtein": "High protein",
    "generateBtn": "Generate recipe",
    "generating": "Thinking up your recipe…",
    "generatingHint": "GPT-5.2 is planning ingredients, steps and macros.",
    "needIngredients": "Add at least 2 ingredients.",
    "errorGen": "Generation error. Try again.",
    "recipeReady": "Recipe ready!",
    "reviewDesc": "Saved to your recipe book. You can generate an AI photo.",
    "ingredientsSection": "Ingredients",
    "stepsSection": "Steps",
    "servingsShort": "serv.",
    "macrosAccurate": "Accurate macros",
    "matchedTip": "Computed from the Solano database.",
    "missingLabel": "Optional ingredients that would improve the recipe:",
    "newRecipe": "New",
    "generatePhoto": "Generate AI photo",
    "photoDone": "Photo ready!",
    "photoError": "AI photo error.",
    "done": "Done",
    "goalHint": {
      "weight_loss": "≈ 350–500 kcal · ≥ 20 g protein per serving",
      "maintenance": "≈ 450–650 kcal · balanced macros",
      "muscle_gain": "≈ 600–800 kcal · ≥ 35 g protein per serving"
    }
  },
  "login": {
    "portalTag": "Client Portal",
    "title": "Welcome back.",
    "subtitle": "Sign in with Google to continue your journey with your nutritionist.",
    "googleBtn": "Continue with Google",
    "appleBtn": "Sign in with Apple",
    "hint": "New here? On first sign-in you'll be asked if you're a",
    "hintNut": "nutritionist",
    "hintOr": "or",
    "hintCli": "client",
    "tagline": "Your essence, your balance.",
    "taglineDesc": "The dedicated portal for Solano Essence clients. Nutrition, sports and progress in one place.",
    "discipline": "Clinical nutrition · Sports nutrition",
    "tabGoogle": "Google",
    "tabEmail": "Email",
    "emailLabel": "Email address",
    "emailPlaceholder": "name@example.com",
    "welcomeSub": "Sign in to continue your health journey.",
    "passwordLabel": "Password",
    "loginBtn": "Sign in",
    "noAccount": "Don't have an account?",
    "registerLink": "Sign up",
    "registerTitle": "Create your account",
    "registerSubtitle": "Register with email and password to get started.",
    "inviteLabel": "Beta invite code",
    "inviteHint": "Provided with your beta invitation",
    "invite": {
      "required": "An invite code is required. Ask your nutritionist.",
      "invalid": "Invalid code. Double-check it or request a new one.",
      "used": "This code has already been used.",
      "revoked": "This code has been revoked.",
      "emailMismatch": "This code is tied to a different email. Use the address your nutritionist gave you."
    },
    "nameLabel": "Full name",
    "confirmPasswordLabel": "Confirm password",
    "registerBtn": "Create account",
    "haveAccount": "Already have an account?",
    "loginLink": "Sign in",
    "passwordsDontMatch": "Passwords do not match",
    "passwordTooShort": "Password must be at least 6 characters",
    "forgotPassword": "Forgot password?",
    "or": "or",
    "invalidCredentials": "Incorrect email or password."
  },
  "forgot": {
    "tag": "Password recovery",
    "title": "Reset your password",
    "subtitle": "Enter your email: if your account exists, you'll get a link to set a new password.",
    "tagline": "We'll help you back in — safely.",
    "taglineDesc": "You'll receive a secure link by email. The link is valid for 60 minutes.",
    "submitBtn": "Send reset link",
    "sentTitle": "Check your email",
    "sentBody": "If the address you entered matches a Solano Essence account, you'll get an email with a link to reset your password.",
    "sentHint": "Can't find the email? Check your spam and promotions folders.",
    "backToLogin": "Back to login"
  },
  "reset": {
    "tag": "New password",
    "title": "Choose your new password",
    "subtitle": "It must be at least 6 characters. We'll sign you in automatically after the change.",
    "tagline": "A safe new start.",
    "taglineDesc": "After confirming the new password you'll be redirected to your personal space.",
    "newPasswordLabel": "New password",
    "confirmPasswordLabel": "Confirm new password",
    "submitBtn": "Confirm new password",
    "success": "Password updated!",
    "invalidTitle": "Invalid link",
    "invalidBody": "The link is missing or invalid. Request a new one from the Forgot password screen."
  },
  "profileSetup": {
    "hint": "One last step",
    "title": "Your profile",
    "subtitle": "We need a few details to automatically calculate your daily calories and macros.",
    "goalLabel": "Your goal",
    "activityLabel": "Activity level",
    "submit": "Calculate & continue",
    "skip": "Skip for now",
    "savedOk": "Profile saved — calories calculated!",
    "privacyNote": "You can update these values anytime from your Profile.",
    "errAge": "Invalid age (10-120)",
    "errHeight": "Invalid height (100-250 cm)",
    "errWeight": "Invalid weight (30-300 kg)"
  },
  "onboarding": {
    "welcome": "Welcome",
    "title": "How will you use the app?",
    "subtitle": "Pick your role to continue. You can always contact support to change it.",
    "nutTitle": "I'm the Nutritionist",
    "nutDesc": "Manage clients, build AI-assisted meal plans, track progress and appointments.",
    "cliTitle": "I'm a Client",
    "cliDesc": "Follow your plan, track weight & measurements, log meals, book consults.",
    "inviteTitle": "Invite code",
    "inviteDesc": "Enter the code from your nutritionist to link your profile.",
    "inviteLabel": "Invite code",
    "invitePlaceholder": "E.G. A1B2C3D4",
    "linkMe": "Link me",
    "inviteRequired": "Please enter the invite code",
    "inviteInvalid": "Invalid code",
    "linkedOk": "Linked to your nutritionist!",
    "yourCode": "Your invite code",
    "shareCodeDesc": "Share this code with your clients — they'll use it to join your practice.",
    "goToDash": "Go to dashboard →",
    "clientOptionsTitle": "How would you like to start?",
    "clientOptionsDesc": "You can join a nutritionist right away with an invite code, or start on your own. You can link a nutritionist any time from your profile.",
    "recommended": "Recommended",
    "withInviteTitle": "I have an invite code",
    "withInviteDesc": "Your nutritionist gave you a code — join their practice.",
    "orNoCode": "Or",
    "soloTitle": "Use the app solo",
    "soloDesc": "Track your progress by yourself. Link a nutritionist whenever you're ready.",
    "soloFeat1": "Track weight, measurements and goals",
    "soloFeat2": "Daily food diary",
    "soloFeat3": "Connect WHOOP, Apple Health and other wearables",
    "startSolo": "Start solo",
    "canLinkLater": "You can link a nutritionist later from your profile.",
    "soloOk": "Welcome! You can start tracking your progress."
  },
  "nav": {
    "dashboard": "Dashboard",
    "clients": "Clients",
    "appointments": "Appointments",
    "myPlan": "My plan",
    "weeklyMenu": "Weekly menu",
    "diary": "Food diary",
    "progress": "Progress",
    "profile": "Profile",
    "chat": "Chat",
    "recipes": "Recipes",
    "workouts": "Workouts",
    "pantry": "Pantry",
    "friends": "Friends",
    "restaurant": "At the restaurant",
    "plate": "Plate",
    "menu": "Menu",
    "openMenu": "Open menu"
  },
  "plate": {
    "title": "The Solano Essence Plate Principle",
    "builder": {
      "title": "Build your balanced plate",
      "subtitle": "Compose your meal – simple and without counting calories.",
      "chooseVeg": "Pick your vegetables first.",
      "addProtein": "Great! Now add a protein source.",
      "addCarbs": "Add some complex carbs.",
      "moreVeg": "Almost there – a bit more veg!",
      "balanced": "Your plate is balanced!",
      "fatsExtra": "small extra",
      "actPhoto": "Photograph plate",
      "actPantry": "From my pantry",
      "actSuggest": "Suggest a dish",
      "actSave": "Save as meal",
      "actGenerate": "Generate recipe",
      "genBusy": "Creating your recipe…",
      "genDone": "Recipe created! Generating photo…",
      "saved": "Meal saved! Find it in your diary.",
      "reset": "Clear plate",
      "ruleTip1": "Protein keeps you full and protects your muscles – e.g. chicken, fish, eggs, tofu or legumes.",
      "ruleTip2": "Vegetables add volume, vitamins and fibre with few calories.",
      "ruleTip3": "Sugary drinks are hidden calories – water or unsweetened tea are the best choice."
    },
    "check": {
      "btn": "Photo plate check",
      "busy": "Analysing your plate…",
      "hint": "Photograph your plate – the AI checks the 50/25/25 split.",
      "resultTitle": "Your plate check",
      "detected": "Detected",
      "missing": "Still missing",
      "fatsSeen": "Healthy fats detected",
      "noFood": "No food detected – please photograph your plate.",
      "reward": "+15 Solano points for your balanced plate!"
    },
    "subtitle": "Balanced meals without counting every calorie",
    "intro": "Eating well shouldn't be complicated. With the Solano Essence Plate Principle you can build balanced meals just by looking at the proportions on your plate — no calorie counting required.",
    "centerLabel": "Your plate",
    "ofYourPlate": "of your plate",
    "slice": {
      "veg": "Vegetables",
      "protein": "Protein",
      "carbs": "Complex carbs"
    },
    "items": {
      "veg": [
        "Salad",
        "Broccoli",
        "Zucchini",
        "Peppers",
        "Tomatoes",
        "Cauliflower",
        "Seasonal vegetables",
        "Spinach",
        "Carrots",
        "Cucumber",
        "Eggplant",
        "Pumpkin",
        "Mushrooms",
        "Fennel",
        "Rocket"
      ],
      "protein": [
        "Chicken",
        "Turkey",
        "Fish",
        "Eggs",
        "Skyr",
        "Low-fat quark",
        "Tofu",
        "Legumes",
        "Salmon",
        "Tuna",
        "Shrimp",
        "Tempeh",
        "Cottage cheese",
        "Lean beef"
      ],
      "carbs": [
        "Rice",
        "Wholegrain pasta",
        "Potatoes",
        "Oats",
        "Quinoa",
        "Wholegrain bread",
        "Sweet potatoes",
        "Bulgur",
        "Millet",
        "Wholegrain couscous"
      ],
      "fats": [
        "Extra virgin olive oil",
        "Avocado",
        "Nuts",
        "Seeds",
        "Almonds",
        "Walnuts",
        "Flax seeds",
        "Chia seeds"
      ]
    },
    "fats": {
      "title": "Healthy fats in moderation",
      "subtitle": "No dedicated slice — add them in small amounts to every meal."
    },
    "rules": {
      "title": "The 3 Solano Essence rules",
      "r1": "Include a protein source in every meal.",
      "r2": "Fill half of your plate with vegetables.",
      "r3": "Drink mostly water and limit sugary drinks."
    }
  },
  "plateCheck": {
    "title": "Solano Plate",
    "tipPrefix": "Tip:",
    "slice": {
      "veg": "Veg",
      "protein": "Protein",
      "carbs": "Carbs",
      "fats": "Healthy fats"
    },
    "assigned": "Assignment",
    "extras": "Extras",
    "unknown": "Not recognised",
    "notDetected": "not detected – please review",
    "fatsMissing": "missing – e.g. olive oil, avocado, nuts",
    "fatsHint": "A side element of the plate, not part of the 50/25/25 split.",
    "satFatTitle": "Quite a bit of saturated fat today:",
    "satFatHint": "totally fine now and then – tomorrow lean towards olive oil, nuts or fish.",
    "editAssign": "Edit",
    "verdict": {
      "excellent": "Great 50/25/25 balance",
      "good": "Well balanced",
      "adjust": "Needs rebalancing"
    },
    "tip": {
      "more_veg": "add more vegetables — they should cover half the plate.",
      "more_protein": "add a protein source (chicken, fish, eggs, legumes).",
      "less_carbs": "ease up on the carbs and give that room to veg instead.",
      "less_protein": "protein is high — balance with vegetables and whole grains.",
      "rebalance": "try to shift portions closer to 50/25/25.",
      "add_fats": "add a healthy fat source: 1 tbsp olive oil, ½ avocado or a handful of nuts.",
      "swap_fats": "swap some saturated fats (butter, cream, cured meats) for olive oil, avocado or fish."
    }
  },
  "plateHistory": {
    "title": "Plate trend",
    "subtitle": "Last {days} days",
    "average": "7-day avg",
    "empty": "No data yet",
    "dataDays": "{n} days with data",
    "targetShort": "target 50/25/25"
  },
  "plateToday": {
    "target": "Target",
    "tomorrow": "Do better tomorrow",
    "keepUp": "Keep it up — your plate was balanced today!",
    "shareTitle": "Share Solano plate",
    "storyKicker": "My plate today",
    "detailsLink": "Open Plate Principle",
    "summary": {
      "excellent": "your plate was almost perfectly balanced today.",
      "good": "your plate was good today — small tweaks will pay off.",
      "adjust": "The distribution deviates from the plate principle. Please review the recognised foods and portions."
    },
    "title": "Today's plate",
    "plateOn": "Plate for",
    "empty": "No lunch or dinner logged",
    "emptyHint": "The Solano Plate is measured on main meals."
  },
  "workouts": {
    "last30": "Last 30 days",
    "title": "Workouts",
    "subtitle": "Track cardio, gym and stretching",
    "newBtn": "New workout",
    "dialogTitle": "Log a workout",
    "typeLabel": "Type",
    "typeCardio": "Cardio",
    "typeStrength": "Strength",
    "typeFlexibility": "Stretching",
    "typeSport": "Sport",
    "typeOther": "Other",
    "nameLabel": "Name",
    "namePlaceholder": "e.g. Park run, Push day…",
    "dateLabel": "Date",
    "durationLabel": "Duration (min)",
    "intensityLabel": "Intensity",
    "intensity_low": "Low",
    "intensity_medium": "Medium",
    "intensity_high": "High",
    "kcalLabel": "Kcal burned",
    "kcalAuto": "auto",
    "kcalHint": "Leave empty for auto estimate based on weight and intensity.",
    "exercisesLabel": "Exercises",
    "addExercise": "Add exercise",
    "addSet": "Add set",
    "exercisePh": "e.g. Bench press, Squat…",
    "reps": "reps",
    "notesLabel": "Notes",
    "notesPh": "How did the workout feel?",
    "save": "Save",
    "saved": "Workout saved",
    "needName": "Please add a name",
    "deleted": "Workout deleted",
    "confirmDelete": "Delete this workout?",
    "planned": "Planned",
    "emptyState": "No workouts yet. Log your first one!",
    "weekCount": "7d sessions",
    "weekMin": "7d minutes",
    "weekKcal": "7d kcal",
    "workout": "workout",
    "workoutsShort": "workouts",
    "markDone": "I trained",
    "markSkip": "No training",
    "markSkipOk": "Noted — no training today",
    "markSkipError": "Couldn't save, try again?",
    "markRestDay": "Rest day",
    "planTrainingCta": "Plan training",
    "addAnotherCta": "Add another workout",
    "dayIsRestDay": "Rest day",
    "dayIsPlanned": "Planned training today",
    "dayIsPlannedFuture": "Planned training day",
    "dayIsFuture": "Upcoming day",
    "dayIsFree": "Free day",
    "unskipCta": "Trained after all?",
    "unskipOk": "Rest day removed",
    "changeReasonCta": "Change reason",
    "pickReasonTitle": "What's going on today?",
    "reasonRestDay": "Rest day",
    "reasonSick": "Sick",
    "reasonNoTime": "No time",
    "reasonPain": "Pain",
    "reasonOther": "Other",
    "skipNoReason": "No reason",
    "skipNoReasonCta": "Save without reason",
    "calLegendSkip": "Rest day",
    "calLegendRecovery": "Recovery",
    "dayIsRecovery": "Deliberate rest",
    "recoveryQuote": "Recovery is part of progress. Your body gets stronger during the pauses.",
    "recoveryDoneTitle": "Recovery is progress",
    "recoveryStreakStrip": "Recovery Streak: {n} week",
    "recoveryNextBadge": "Next level",
    "recoveryWeeksUnit": "weeks",
    "badge_recovery_starter": "🌿 Recovery Starter",
    "badge_recovery_balance": "🌙 Recovery Balance",
    "badge_regeneration_pro": "🧘 Recovery Pro",
    "trainingPlanTag": "My training plan",
    "trainingPlanEmpty": "No training days yet",
    "trainingPlanQ": "Which days do you usually train?",
    "trainingPlanHint": "Days you don't select aren't automatically counted as rest days.",
    "trainingPlanApply": "Apply",
    "trainingPlanSaved": "Training plan saved",
    "trainingPlanTypeTitle": "Training type per day",
    "skipNudgeTag": "Life happens",
    "skipNudgeTitle": "{n} rest days in a row — want to reshuffle?",
    "skipNudgeBody": "No stress. Pick different training days that fit your week better. We'll follow along.",
    "skipNudgeCta": "Reshuffle my week",
    "skipNudgeLater": "Maybe later",
    "calLegendDone": "Workout",
    "calLegendToday": "Today",
    "calLegendSelected": "Selected",
    "calLegendPlanned": "Planned",
    "todayCount": "today",
    "kcalEstimatedTip": "Estimated kcal (weight & MET based)",
    "totalSets": "Total sets",
    "totalVolume": "Total volume",
    "noExtraDetails": "No extra details.",
    "settingKcalInBudgetLabel": "Default for new days: add burned kcal to my budget",
    "settingKcalInBudgetHelp": "e.g. 2000 kcal + 300 burned = 2300 available. You can still switch it per day on the dashboard.",
    "kcalBudgetShort": "Kcal budget with workout",
    "kcalBudgetOn": "Workout kcal now in budget",
    "kcalBudgetOff": "Workout kcal separate from budget",
    "wearableReadOnly": "Synced from wearable — not editable here"
  },
  "workoutPhoto": {
    "openBtn": "From photo",
    "title": "Add from photo",
    "subtitle": "Snap or upload a workout summary screenshot (Speediance, Apple Fitness, Garmin…). AI extracts duration, kcal & type.",
    "pickPhoto": "Take or choose photo",
    "hint": "End-of-workout summary screens work best",
    "batchHint": "Pick multiple photos at once (up to a full week)",
    "analyzing": "Analyzing…",
    "analyzingBatch": "Analyzing {done}/{total}…",
    "notRecognized": "No photo looks like a workout summary.",
    "itemNotRecognized": "Not recognized",
    "extracted": "Extracted — review before saving",
    "extractedBatch": "{ok} workouts recognized · {err} unrecognized",
    "name": "Name",
    "type": "Type",
    "date": "Date",
    "dateAutoTooltip": "Date auto-detected from the image",
    "duration": "Duration (min)",
    "durationShort": "min",
    "kcal": "Kcal",
    "intensity": "Intensity",
    "notes": "Notes",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "types": {
      "strength": "Strength",
      "cardio": "Cardio",
      "flexibility": "Stretching",
      "sport": "Sport",
      "other": "Other"
    },
    "retake": "Retake",
    "save": "Save workout",
    "saveAll": "Save all ({n})",
    "savedToast": "Workout saved from photo",
    "batchSavedToast": "{n} workouts saved from photos",
    "batchFailedToast": "{n} workouts failed to save"
  },
  "nutDash": {
    "hello": "Hi,",
    "subtitle": "Here's an overview of your practice.",
    "appStatsTag": "Owner",
    "appStatsTitle": "App statistics",
    "appStatsSub": "All app activity at a glance",
    "inviteCodeTag": "Practice invite code",
    "inviteShare": "Share it with new clients to link them to your practice.",
    "copyCode": "Copy code",
    "copied": "Copied!",
    "shareCode": "Share",
    "shareMessage": "Hi! To connect with me on the Solano Essence app, use this invite code:",
    "activeClients": "Active clients",
    "totalClients": "Total clients",
    "subtitleToday": "Here's your snapshot for today.",
    "todayImportant": "Today important",
    "todayImportantEmpty": "All green. Nothing to do right now.",
    "inviteTitle": "Invite a client",
    "alertNeverActive": "Never active",
    "alertInactiveSince": "Since",
    "alertDays": "days inactive",
    "alertFading": "Fading activity",
    "alertContact": "Contact",
    "alertOpen": "Open",
    "alertNewLogs": "New diary logs",
    "alertLogOne": "entry today",
    "alertLogMany": "entries today",
    "alertOpenFeed": "Go to feed",
    "alertDaysShort": "days",
    "alertKcalOverfix": "(target exceeded)",
    "alertProteinTarget": "protein target",
    "pendingRequests": "Pending requests",
    "recentClients": "Recent clients",
    "seeAll": "See all",
    "noClients": "No clients yet",
    "noClientsDesc": "Share your invite code to get started.",
    "thresholdsTag": "Settings",
    "thresholdsTitle": "Adjust alert thresholds",
    "thresholdsKcalOver": "Alert when kcal over target",
    "thresholdsKcalOverHint": "Notify when client exceeds kcal target for at least N days",
    "thresholdsProteinLow": "Alert when protein under target",
    "thresholdsProteinLowHint": "Notify when client stays below protein target for at least N days",
    "thresholdsDays": "Days",
    "thresholdsThreshold": "% Threshold",
    "thresholdsSave": "Save",
    "upcomingAppts": "Upcoming appointments",
    "noAppts": "No appointments",
    "noApptsDesc": "Confirmed bookings will show up here.",
    "open": "Open",
    "goalToDefine": "goal not set"
  },
  "clientsList": {
    "filterAll": "All",
    "filterAction": "Action needed",
    "filterCheckin": "Check-in due",
    "filterNew": "New",
    "msg": "Message",
    "more": "More",
    "adherence": "Adherence",
    "noGoal": "No goal set",
    "empty": "No clients",
    "title": "Clients",
    "subtitle": "Manage your client roster and their plans.",
    "searchPh": "Search client…",
    "emptyDesc": "Share your invite code from the dashboard to add clients.",
    "newBadge": "New",
    "statusGreen": "On track",
    "statusAmber": "Needs attention",
    "statusRed": "Action needed"
  },
  "betaInvites": {
    "title": "Beta Invites",
    "subtitle": "Single-use codes to invite your clients",
    "active": "active",
    "newInvite": "New invite",
    "labelPh": "Client name (optional)",
    "emailPh": "Client email (optional)",
    "emailHint": "Add the email to make sure only that client can redeem the code.",
    "generate": "Generate",
    "created": "Code created",
    "empty": "No invites yet. Generate your first one above.",
    "usedBy": "used by",
    "copyCode": "Copy code",
    "shareLink": "Share link",
    "revoke": "Revoke",
    "linkCopied": "Link copied",
    "shareText": "Hi {name}! Here is your invite for Solano Essence:",
    "waTemplate": "Hi {name}! 👋\n\nWelcome to Solano Essence — your personalised nutrition app.\n\nRegister here with your invite code:\n{url}\n\nIf the sign-up asks for the code manually, use the one in the link.\n\nSpeak soon! 🥗",
    "sendWhatsApp": "Send via WhatsApp",
    "showQr": "Show QR code",
    "qrTag": "QR code",
    "lastEntry": "Last entry",
    "mWeight": "Weight",
    "mScore": "Score",
    "mAdherence": "Adherence",
    "mStatus": "Status",
    "ctaMessage": "Message",
    "ctaCoachAi": "Coach AI",
    "ctaPlan": "Edit plan",
    "attentionTitle": "Attention",
    "checkinTitle": "Client check-in",
    "lastCheckin": "Last check-in",
    "nextCheckin": "Next check-in",
    "cadence": "Cadence",
    "cadWeekly": "Weekly",
    "cadBiweekly": "Bi-weekly",
    "cadMonthly": "Monthly",
    "lastNote": "Last note",
    "addNote": "Add note",
    "notePh": "What went well this week? What's missing?",
    "completeCheckin": "Complete check-in",
    "checkinDone": "Check-in saved",
    "cadenceSaved": "Cadence updated",
    "qrTitle": "Invite client",
    "qrHint": "Have your client scan this to open the sign-up page with the code pre-filled.",
    "defaultName": "client",
    "status": {
      "active": "Active",
      "used": "Used",
      "revoked": "Revoked"
    }
  },
  "nutJournal": {
    "title": "Client journal",
    "lastNDays": "Last {n} days",
    "empty": "The client hasn't written any journal notes yet.",
    "noContent": "No note — replies only.",
    "replyPlaceholder": "Write a reply to the client…",
    "replySent": "Reply sent"
  },
  "providerPrefs": {
    "title": "Data preferences",
    "subtitle": "Pick which device to use for each metric",
    "noDevices": "Connect a device first to set preferences",
    "auto": "Auto (max)",
    "saved": "Preferences saved",
    "resetBtn": "Reset data",
    "resetConfirm": "Wipe wearable data for the last 7 days? The next sync will re-fetch from connected providers.",
    "resetDone": "Cleared {n} days. Tap Sync now to refresh.",
    "metric": {
      "sleep": "Sleep",
      "sleepHint": "Shown on the SLEEP card",
      "steps": "Steps",
      "stepsHint": "Daily step count",
      "hrv": "HRV",
      "hrvHint": "Heart-rate variability (ms)",
      "resting_hr": "Resting HR",
      "resting_hrHint": "Resting heart rate (bpm)"
    }
  },
  "clientDetail": {
    "heroSection": "Key metrics & Coach AI",
    "tabOverview": "Overview",
    "tabNutrition": "Nutrition",
    "tabProgress": "Progress",
    "tabProfile": "Profile",
    "tapForDetails": "Tap for details",
    "hasComment": "Has comment",
    "noLogsForBadge": "No logs",
    "lastEntry": "Last entry",
    "mWeight": "Weight",
    "mScore": "Score",
    "mAdherence": "Adherence",
    "mStatus": "Status",
    "ctaMessage": "Message",
    "ctaCoachAi": "Coach AI",
    "ctaPlan": "Edit plan",
    "attentionTitle": "Attention",
    "checkinTitle": "Client check-in",
    "lastCheckin": "Last check-in",
    "nextCheckin": "Next check-in",
    "cadence": "Cadence",
    "cadWeekly": "Weekly",
    "cadBiweekly": "Bi-weekly",
    "cadMonthly": "Monthly",
    "lastNote": "Last note",
    "addNote": "Add note",
    "notePh": "What went well this week? What is missing?",
    "completeCheckin": "Complete check-in",
    "checkinDone": "Check-in saved",
    "cadenceSaved": "Cadence updated",
    "tileAdherence": "Adherence",
    "tileAdherenceSub": "14 days",
    "tileJournal": "Client journal",
    "tileJournalSub": "30 days",
    "tileProfile": "Profile",
    "tileProfileSub": "Goal, age, height",
    "tileTrends": "Trends",
    "tileTrendsSub": "Weight & adherence",
    "tileWearable": "Wearable",
    "tileWearableSub": "HRV, sleep, steps",
    "tileDiary": "Food diary",
    "tileDiarySub": "Meals & comments",
    "profile": "Profile",
    "goal": "Goal",
    "activity": "Activity",
    "sport": "Sport",
    "height": "Height",
    "startingWeight": "Starting weight",
    "kcalTarget": "Kcal target",
    "allergies": "Allergies",
    "weightTrend": "Weight trend",
    "needMoreWeights": "Client hasn't logged enough weights yet.",
    "currentPlan": "Current plan",
    "noPlan": "No plan assigned.",
    "planTargetsTitle": "Plan targets",
    "avgIntakeTitle": "Average intake (last 7 days)",
    "avgIntakeEmpty": "No meals logged in the last 7 days.",
    "microsTitle": "Average micronutrients",
    "dailyAverage": "daily average",
    "recentLogs": "Client food diary",
    "noLogs": "No logs yet.",
    "noLogsForDay": "No logs for this day.",
    "jumpToDay": "Jump to day",
    "today": "Today",
    "yesterday": "Yesterday",
    "quickNotes": "Quick notes",
    "clientReplyLabel": "Client reply",
    "qn_great": "Great meal",
    "qn_portion": "Watch the portion",
    "qn_veggies": "Add veggies",
    "qn_protein": "More protein",
    "qn_water": "Drink more water",
    "qn_carbs": "Reduce carbs",
    "qn_timing": "Review meal timing",
    "qn_sugar": "Watch the sugar",
    "commentTitle": "Comment on this meal",
    "commentLabel": "Your comment (visible to the client)",
    "commentPlaceholder": "Write a short feedback to the client…",
    "commentSaved": "Comment sent to the client",
    "commentCleared": "Comment removed",
    "createPlan": "Create plan",
    "updatePlan": "Update plan",
    "weeklyPreview": "Weekly PDF",
    "weeklySend": "Send now",
    "weeklyLoading": "Generating PDF…",
    "weeklySending": "Sending…",
    "weeklySent": "Report sent by email",
    "backClients": "Clients",
    "monthlyReport": "Monthly report",
    "printPdf": "Print / PDF",
    "period": "Period",
    "client": "Client",
    "startWeight": "Start weight",
    "endWeight": "End weight",
    "delta": "Delta",
    "diaryDays": "Diary days",
    "avgKcalDay": "Avg kcal/day",
    "avgWaterDay": "Avg water/day",
    "glasses": "glasses",
    "avgSleep": "Avg sleep",
    "avgHrv": "Avg HRV",
    "progressPhotosTitle": "Progress photos",
    "reportFooter": "Total meals: {meals} · Progress photos: {photos} · Avg resting HR: {rhr}"
  },
  "builder": {
    "title": "Meal plan builder",
    "for": "For",
    "aiTitle": "AI Generator (GPT-5.2)",
    "aiDesc": "Prefill a plan based on the client's profile. Then edit freely.",
    "caloriesTarget": "Target calories",
    "preferences": "Preferences / notes",
    "preferencesPh": "e.g. no lactose, more fish, sweet breakfast",
    "generate": "Generate with AI",
    "generating": "Generating…",
    "titleField": "Title",
    "clientNotes": "Notes for the client",
    "addMeal": "Add meal",
    "addDay": "Add day (e.g. training)",
    "savePlan": "Save plan",
    "mealName": "Meal name",
    "mealTime": "Time",
    "mealDesc": "Description (foods, portions)",
    "generatedOk": "Plan generated with AI. You can edit and save it.",
    "savedOk": "Plan saved and assigned to the client",
    "defaultDayLabel": "Typical day",
    "trainingDayLabel": "Training day",
    "dayTypeGeneric": "generic",
    "dayTypeTraining": "training",
    "dayTypeRest": "rest",
    "aiErrorPrefix": "AI error"
  },
  "apptsNut": {
    "title": "Appointments",
    "subtitle": "Manage booking requests from your clients.",
    "pendingSection": "Pending requests",
    "confirmedSection": "Confirmed",
    "archiveSection": "Archive",
    "markDone": "Mark as done",
    "empty": "Nothing here",
    "confirmed": "Confirmed",
    "cancelled": "Cancelled",
    "updated": "Updated"
  },
  "mascots": {
    "section": "Mascot moments",
    "title": "Your collection",
    "steps": "Step goal",
    "stepsHint": "Reach your step goal",
    "training": "Workout",
    "trainingHint": "Complete a workout",
    "water": "2L water",
    "waterHint": "Drink 2 liters in one day",
    "sleep": "Sleep goal",
    "sleepHint": "Reach your sleep goal",
    "unlockedCount": "{n} of {total} unlocked"
  },
  "shop": {
    "unknown": {
      "title": "Unknown product – help Solano learn it",
      "subtitle": "Photograph the nutrition label. The AI reads the values, you confirm – and next time Solano recognises the product instantly.",
      "photoLabel": "Photograph nutrition label",
      "analyzing": "AI is reading the label …",
      "manual": "Enter manually instead",
      "analyzeFailed": "Label not readable – please retake the photo or enter manually.",
      "aiRead": "Read by the AI – please double-check",
      "name": "Product name",
      "brand": "Brand",
      "serving": "Serving (e.g. 30 g)",
      "ingredients": "Ingredients (optional, for the Mediterranean bonus)",
      "save": "Save & rate",
      "saved": "Product saved – thank you!",
      "nameRequired": "Please enter a product name.",
      "shared": "Learned products are available to all Solano users.",
      "f": {
        "kcal": "kcal",
        "protein": "Protein g",
        "carbs": "Carbs g",
        "sugar": "Sugar g",
        "fat": "Fat g",
        "satfat": "Sat. fat g",
        "fiber": "Fiber g",
        "salt": "Salt g"
      }
    },
    "logToDiary": "Add to diary",
    "perServing": "Values per serving ({s})",
    "show100": "show per 100 g",
    "showServing": "show per serving",
    "clearConfirm": "Really clear the history?",
    "yes": "Yes",
    "no": "No",
    "disclaimer": "The Solano score is a guide and does not replace nutritional or medical advice.",
    "info": {
      "scores": "Nutri-Score: the official product rating (A–E). Solano score: our 0–100 rating, tailored to your goal.",
      "thresholds": "Levels: 70+ “Buy it” · 40–69 “Ok in moderation” · below 40 “Better not”.",
      "how": "How the score is built: base from the Nutri-Score, then plus/minus for sugar, saturated fat, salt, fiber, protein, processing level, additives and Mediterranean ingredients – weighted for your goal."
    },
    "med": {
      "med_good_ingredients": "Fits the Mediterranean diet: good ingredients",
      "med_good_natural": "Fits the Mediterranean diet: minimally processed",
      "med_neutral": "Mediterranean-neutral – fine in moderation",
      "med_poor_processed": "Not very Mediterranean: ultra-processed",
      "med_poor_sugar": "Not very Mediterranean: high sugar or sweeteners"
    },
    "altTip": {
      "food": "Coach tip: go for unprocessed basics – plain yogurt, skyr, nuts, fruit or whole grains beat any ready-made product.",
      "beverage": "Coach tip: water, unsweetened tea or coffee – add lemon or mint if you want flavour."
    },
    "addToList": "Add to shopping list",
    "onList": "On the list",
    "addedToList": "Added to your shopping list",
    "alreadyOnList": "Already on your shopping list",
    "listTicked": "Ticked off and added to your pantry: {name}",
    "listTickedTitle": "Ticked off your list – now in your pantry",
    "verifiedSeal": "Verified by Solano",
    "verifiedHint": "The nutrition facts of this product were checked by the Solano team.",
    "miniList": {
      "title": "Your shopping list",
      "open": "{n} open",
      "more": "+{n} more"
    },
    "openList": "Open list",
    "per100g": "Values per 100 g",
    "per100ml": "Beverage – values per 100 ml",
    "stats": {
      "title": "Your shopping balance",
      "smartRate": "How often you picked “Buy it” over “Better not” in the last {days} days",
      "summary": "{total} scans · avg score {avg}"
    },
    "altTitle": "Better alternative",
    "altLoading": "Looking for a healthier alternative …",
    "altTap": "Tap for details",
    "title": "Shopping Check",
    "subtitle": "Scan a product in the store – Solano tells you if it belongs in your cart.",
    "hint": "Hold the barcode (EAN) inside the frame",
    "enterManually": "Enter code manually",
    "checking": "Checking product …",
    "notFound": "Product not found – try another code.",
    "error": "Check failed. Please try again.",
    "solanoScore": "Solano Score",
    "verdict": {
      "buy": "Buy it",
      "moderate": "Ok in moderation",
      "avoid": "Better not"
    },
    "goal": {
      "lose": "Weighted for your goal: weight loss",
      "gain": "Weighted for your goal: muscle gain",
      "maintain": "Balanced rating"
    },
    "reason": {
      "sugar_high": "Very high sugar: {v} g/100 g",
      "sugar_mid": "High sugar: {v} g/100 g",
      "sugar_low": "Low sugar: {v} g/100 g",
      "satfat_high": "High saturated fat: {v} g/100 g",
      "satfat_mid": "Some saturated fat: {v} g/100 g",
      "salt_high": "High salt: {v} g/100 g",
      "salt_mid": "Some salt: {v} g/100 g",
      "fiber_high": "Rich in fiber: {v} g/100 g",
      "fiber_mid": "Good fiber: {v} g/100 g",
      "protein_high": "High protein: {v} g/100 g",
      "protein_mid": "Good protein source: {v} g/100 g",
      "kcal_high": "Calorie dense: {v} kcal/100 g",
      "nova_4": "Ultra-processed (NOVA 4)",
      "nova_3": "Processed (NOVA 3)",
      "nova_1": "Unprocessed (NOVA 1)",
      "additives": "{v} additives",
      "med_olive": "Mediterranean: olive oil / olives",
      "med_nuts": "Mediterranean: nuts / almonds",
      "med_wholegrain": "Mediterranean: whole grain",
      "med_legumes": "Mediterranean: legumes",
      "med_fish": "Mediterranean: fish",
      "palm_oil": "Contains palm oil",
      "few_ingredients": "Short ingredient list – minimally processed",
      "bev_water": "Water – the best choice",
      "bev_unsweetened": "Unsweetened, virtually calorie-free",
      "bev_sugar_high": "Sugary drink: {v} g sugar/100 ml",
      "bev_sugar_mid": "High sugar: {v} g/100 ml",
      "bev_sugar_some": "Some sugar: {v} g/100 ml",
      "bev_sugar_low": "Low sugar: {v} g/100 ml",
      "bev_kcal_high": "Liquid calories: {v} kcal/100 ml",
      "sweeteners": "Contains sweeteners",
      "fruit_juice": "100% fruit juice (natural sugar)",
      "alcohol": "Alcoholic beverage"
    },
    "coach": "Coach",
    "coachThinking": "Your coach is taking a look …",
    "coachUnavailable": "Coach comment not available right now.",
    "n": {
      "kcal": "kcal",
      "protein": "Protein",
      "sugar": "Sugar",
      "salt": "Salt"
    },
    "next": "Scan next",
    "logAnyway": "Log anyway",
    "history": "Recently scanned",
    "clear": "Clear",
    "emptyHistory": "Your scanned products will appear here for comparison.",
    "cameraStarting": "Starting camera …",
    "retry": "Retry",
    "fromPhoto": "From photo",
    "err": {
      "permission": "Camera access denied. Allow it in Settings or use a photo.",
      "nodevice": "No camera found.",
      "generic": "Camera could not be started.",
      "notfound": "No barcode detected in the photo."
    }
  },
  "quickTrack": {
    "title": "Quick track",
    "qrScan": "Scan QR recipe",
    "addMeal": "Add meal",
    "photo": "AI photo",
    "voice": "Voice",
    "barcode": "EAN scanner",
    "shop": "Shopping Check",
    "fridge": "From the fridge",
    "search": "Search food",
    "manual": "Manual entry"
  },
  "cliDash": {
    "weightSaved": "Weight saved",
    "hi": "Hi,",
    "waterUndo": "Undo",
    "waterCustom": "Custom",
    "waterCustomPh": "e.g. 330",
    "waterSettings": "Water settings",
    "waterTargetLabel": "Daily goal (litres)",
    "foodWater": "+ Water from food: ~{ml} ml",
    "waterContainers": "Your containers",
    "waterAddContainer": "+ Container",
    "waterContainerNamePh": "Name (e.g. bottle)",
    "checkinTitle": "Daily check-in",
    "checkinOutTitle": "Check-in / Check-out",
    "checkinSection": "Check-in · Morning",
    "checkoutSection": "Check-out · Evening",
    "checkoutMoodQ": "How is your day ending?",
    "checkoutSave": "Complete check-out",
    "checkoutSaved": "Check-out saved ✓",
    "checkinMoodQ": "How was your day?",
    "checkinEnergyQ": "How is your energy?",
    "checkinNotePh": "Optional note …",
    "checkinSave": "Complete check-in",
    "checkinSaved": "Daily check-in saved ✓",
    "checkinDone": "Done",
    "of": "of",
    "kcalBurnedShort": "Burned",
    "changePhoto": "Change photo",
    "removePhoto": "Remove photo",
    "avatarUpdated": "Profile photo updated",
    "avatarRemoved": "Profile photo removed",
    "avatarFrame": "Frame",
    "avatarFrameUpdated": "Frame updated",
    "avatarZoom": "Zoom",
    "editAvatar": "Center your photo",
    "journey": "Your journey starts here.",
    "currentWeight": "Current weight",
    "logWeightLabel": "Log weight (kg)",
    "logWeightBtn": "Save",
    "weightLogged": "Weight logged",
    "sinceStart": "since start",
    "nextAppt": "Next appointment",
    "noneProgrammed": "None scheduled.",
    "book": "Book",
    "yourPlan": "Your plan",
    "seeDetail": "See details →",
    "noPlanAssigned": "Your nutritionist hasn't assigned a plan yet.",
    "otherMeals": "more meals",
    "goals": "Your goals",
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "calories": "Calories",
    "kcalLeft": "left",
    "kcalOver": "over",
    "kcalTooLow": "too low",
    "kcalBurned": "kcal daily activity",
    "aiQuotaLeft": "{n} of {total} free AI actions left this month",
    "aiQuotaTitle": "Free photo analyses",
    "aiQuotaUsed": "{used} of {total} used",
    "aiQuotaLeftShort": "{n} left this month",
    "aiQuotaNoneLeft": "All used up — resets next month",
    "aiQuotaPro": "Unlimited with Pro",
    "kcalInfoTitle": "How are the kcal calculated?",
    "kcalInfoTotalHint": "everyday movement today (Apple Health total minus workout kcal) — excluding training.",
    "kcalInfoWorkoutHint": "on top from your logged workouts (WHOOP + manual, deduped within ±5 min).",
    "kcalInfoFallback": "Without Apple Health sync, daily activity is estimated from your steps (~0.04 kcal per step).",
    "kcalConsumed": "eaten",
    "kcalTarget": "target",
    "workoutBonus": "workout",
    "nextMealSuggest": "Next: {meal} ~{kcal} kcal",
    "nextMealDone": "Great work today!",
    "steps": "steps",
    "hydration": "water",
    "goal": "goal",
    "setKcalTarget": "Set kcal target",
    "editKcalTitle": "Daily calorie goal",
    "editKcalHint": "Define how many calories you want to consume per day.",
    "saveTarget": "Save target",
    "planCtaTitle": "Daily targets & macro split",
    "planCtaHint": "Presets (Balanced, Low Carb, High Protein) and set all targets yourself",
    "targetSaved": "Target updated",
    "kcalRange": "Enter a value between 500 and 6000",
    "macros": "Macros",
    "carbs": "Carbs",
    "protein": "Protein",
    "fat": "Fat",
    "sugar": "Sugar",
    "fiber": "Fiber",
    "satFat": "Sat.",
    "salt": "Salt",
    "microsInfo": "Sugar (max 50g WHO), Fiber (30g/day), Saturated fat (max 10% kcal), Salt (max 5g WHO)",
    "showDetails": "Show sugar · fiber · salt",
    "hideDetails": "Hide details",
    "mealsToday": "Meals today",
    "tapToAddMeal": "Tap + to add a meal",
    "mealEmpty": "No meal added",
    "oneMeal": "1 item",
    "manyMeals": "items",
    "addMeal": "Add meal",
    "aiScan": "Scan with AI",
    "openDiary": "Open diary",
    "openPlan": "See plan",
    "activities": "Activities",
    "connectDevice": "Connect device",
    "noPlanShort": "No plan yet"
  },
  "myPlan": {
    "title": "My plan",
    "subtitle": "Your nutritionist's personalized meal plan.",
    "empty": "No plan assigned",
    "emptyDesc": "Your nutritionist will assign one shortly.",
    "notLinkedTitle": "Connect with your nutritionist",
    "notLinkedDesc": "Enter the invite code your nutritionist gave you to receive your personalized plan.",
    "notLinkedHint": "The code has 6 characters (e.g. ABC123). If you don't have it, ask your nutritionist.",
    "translateBtn": "Translate to English",
    "translateOriginal": "View original",
    "translating": "Translating…",
    "translatedBadge": "Translated",
    "translateError": "Translation failed"
  },
  "feed": {
    "title": "Client feed",
    "subtitle": "All your clients' activities in chronological order. Tap a card to open the client.",
    "emptyTitle": "No recent activity",
    "emptyDesc": "Meal photos, weights, measurements and messages from your clients will appear here.",
    "viewByClient": "By client",
    "viewChrono": "Chronological",
    "oneActivity": "activity",
    "manyActivities": "activities",
    "today": "Today",
    "yesterday": "Yesterday",
    "itemOne": "item",
    "itemMany": "items",
    "thumbsUp": "Nice",
    "thumbsSent": "Sent",
    "commentLabel": "Comment",
    "commentedLabel": "Commented",
    "commentPlaceholder": "Write a quick feedback…",
    "commentSent": "Feedback sent to client",
    "mealLogged": "Meal logged",
    "weightLogged": "Weight logged",
    "measurementUpdated": "Measurements updated",
    "progressPhoto": "Progress photo",
    "chatMessage": "New message",
    "angle_front": "front",
    "angle_side": "side",
    "angle_back": "back"
  },
  "progress": {
    "title": "Progress",
    "subtitle": "See your changes over time.",
    "navOverview": "Overview",
    "navBody": "Body",
    "navNutrition": "Nutrition",
    "navHealth": "Devices & apps",
    "navPhotos": "Photos",
    "bmiTitle": "Body Mass Index",
    "bmiUnder": "Underweight",
    "bmiNormal": "Healthy",
    "bmiOver": "Overweight",
    "bmiObese": "Obese",
    "thisWeek": "Last 7 days",
    "noDataConnect": "No data · Connect wearable",
    "monthlyTitle": "Progress",
    "days": "days",
    "weightLabel": "Weight",
    "waistLabel": "Waist",
    "recapNow": "now",
    "recapUnchanged": "unchanged over 30 days",
    "recapNeedTwo": "2 entries needed to show the change",
    "recapNoWaist": "No waist measurement yet – add it under “Body”",
    "recapNoWeight": "No weight logged yet",
    "workoutsLabel": "Workouts",
    "diaryLabel": "Diary",
    "waterLabel": "Water",
    "hitTarget": "daily average",
    "streakLabel": "day streak",
    "streakToast7Title": "7-day hydration streak! 💧",
    "streakToast7Desc": "A full week on target. Your body thanks you!",
    "streakToast14Title": "Two weeks in a row! 🔥",
    "streakToast14Desc": "Hydration is officially a habit now. Keep it going!",
    "streakToast30Title": "30 consecutive days! 🏆",
    "streakToast30Desc": "A full month on target. You're on fire!",
    "aiInsightTitle": "AI Coach",
    "aiInsightEmpty": "Log more data to get a personalized AI insight.",
    "refreshInsight": "Refresh",
    "weightTrend": "Weight trend",
    "goalShort": "Goal",
    "prevPeriod": "Previous period",
    "kcalTrend": "Calorie trend · 30 days",
    "kcalAvg": "avg per day",
    "kcalVsGoal": "kcal vs goal",
    "kcalBand": "Target range",
    "macroTrend": "Macro trend · 30 days",
    "macroProtein": "Protein",
    "macroCarbs": "Carbs",
    "macroCarbsShort": "Carbs",
    "macroTipCta": "See matching recipes",
    "macroRecipesHigh": "Recipes high in {macro}",
    "macroRecipesLow": "Recipes low in {macro}",
    "macroRecipesHint": "Sorted by share of calories per serving – tap to open the recipe.",
    "macroRecipesEmpty": "No matching recipes in your collection yet.",
    "macroFat": "Fat",
    "macroOfGoal": "{pct}% of {goal} g",
    "kcalInBand": "{n} of {total} logged days within target range (±10%)",
    "needMore": "Log at least 2 weights to see the chart.",
    "now": "Now",
    "rangeW": "Week",
    "rangeM": "Month",
    "range3M": "3 months",
    "rangeY": "Year",
    "rangeAll": "All",
    "measChartTitle": "Measurements trend",
    "logMeasurements": "Log measurements",
    "saveMeasurements": "Save measurements",
    "measurementsLogged": "Measurements saved",
    "waist": "Waist (cm)",
    "hips": "Hips (cm)",
    "chest": "Chest (cm)",
    "arm": "Arm (cm)",
    "thigh": "Thigh (cm)",
    "armGroup": "Arm",
    "thighGroup": "Thigh",
    "armLeft": "Left arm",
    "armRight": "Right arm",
    "thighLeft": "Left thigh",
    "thighRight": "Right thigh",
    "calf": "Calf (cm)",
    "calfGroup": "Calf",
    "calfLeft": "Left calf",
    "calfRight": "Right calf",
    "leftShort": "Left",
    "rightShort": "Right",
    "history": "Measurement history",
    "trend": "Measurements trend",
    "needMoreData": "Need at least 2 entries to show the trend.",
    "latest": "Latest",
    "measure": "measure",
    "measures": "measures",
    "needAtLeastOne": "Fill in at least one measurement"
  },
  "weightGoal": {
    "title": "Target weight",
    "setPrompt": "Set your target weight →",
    "currentToTarget": "Current → Target",
    "startCurrentTarget": "Start → Current → Target",
    "remaining": "To go",
    "reached": "Target reached! 🎯",
    "etaLine": "At your current pace ({rate} kg/week) you'll get there in ~{weeks} weeks",
    "etaTooFast": "That's a fast pace ({rate} kg/week). Check in with your nutritionist for a sustainable plan.",
    "etaProjection": "Projection",
    "weeks": "weeks",
    "wrongDirection": "Your weight is trending the opposite way of your goal.",
    "wrongDirectionHint": "Review calories and workouts with your nutritionist.",
    "needMore": "Log your weight for at least 2 consecutive weeks to see a projection.",
    "logFirst": "Log your current weight to get started.",
    "invalid": "Enter a valid weight between 30 and 250 kg",
    "saved": "Target weight saved",
    "cleared": "Target cleared",
    "clearBtn": "Remove target",
    "editBtn": "Edit",
    "milestones": "Sub-goals",
    "milestoneTitle": "Milestone reached! 🎉",
    "milestoneDesc": "You hit {kg} kg — every 2 kg is a big step.",
    "milestoneFinalTitle": "Goal weight reached! 🎯",
    "milestoneFinalDesc": "Congratulations, you've hit your target weight."
  },
  "auth": {
    "accountBlocked": "Your account has been suspended. Please contact support.",
    "blockedTitle": "Your account has been suspended",
    "blockedBody": "This account was suspended for violating our community rules and cannot sign in. If you believe this is a mistake, please contact us – we review every case within 48 hours.",
    "blockedCta": "Contact support: info@solano-essence.com",
    "socialLoginOnly": "This account uses Google or Apple sign-in. Log in with that method or set a password via 'Forgot password?'.",
    "tooManyAttempts": "Too many failed login attempts. Please try again in 15 minutes.",
    "nameRequired": "Please enter your name.",
    "emailExists": "Email already registered. Please log in.",
    "emailExistsSocial": "Email already registered with Google or Apple. Sign in with that method — or set a password via 'Forgot password?'.",
    "resetLinkInvalid": "Link invalid or already used.",
    "resetLinkExpired": "Link expired. Request a new one."
  },
  "admin": {
    "illu_title": "Mascot exercise images",
    "illu_exercises": "exercises",
    "illu_today": "Tonight",
    "illu_last_night": "Last night",
    "illu_eta": "Time left",
    "illu_nights": "{n} nights",
    "illu_window": "Runs at night {w}",
    "illu_running": "running now",
    "illu_next": "next run {at}",
    "illu_remaining": "{n} exercises left",
    "subKind": "Subscription type",
    "subSince": "Since",
    "segNew": "New (7 days)",
    "segInactive": "Inactive (7 days+)",
    "segPaid": "Pro paid",
    "segComp": "Pro gifted",
    "testAccount": "Test account",
    "testMark": "Mark as test account (excluded from stats)",
    "testUnmark": "Remove mark",
    "testMarked": "Marked as test account — excluded from numbers",
    "testUnmarked": "Test mark removed",
    "adherence": "Adherence",
    "untilShort": "until",
    "expiredShort": "expired",
    "activeUsersLegend": "Active users",
    "aiCostMonth": "AI cost this month",
    "aiShareNet": "Share of net revenue",
    "aiUsageEstNote": "Costs = estimates per call type",
    "aiLimitsTitle": "Pro limits per month",
    "countsNote": "Counts exclude test and team accounts — same everywhere.",
    "revenueEstimate": "Estimate from active subscriptions × price",
    "filterAll": "All",
    "onlyPublic": "Public only",
    "onlyPrivate": "Private only",
    "onlyDupes": "Duplicates",
    "publicLabel": "Public",
    "privateLabel": "Private",
    "merge": "Merge",
    "mergeTitle": "Merge duplicate recipes",
    "mergeHint": "Pick the recipe to keep. Favorites and collections of the others are carried over, the duplicates are deleted.",
    "mergeKeep": "Merge",
    "mergeDone": "{n} duplicate(s) merged",
    "ingredientsShort": "ingredients",
    "recipeDeleteTitle": "Really delete this recipe?",
    "recipeDeleteBody": "This cannot be undone.",
    "foodDeleteTitle": "Really delete this food?",
    "editFood": "Edit food",
    "foodName": "Name",
    "per100g": "Nutrition per 100 g",
    "fiberShort": "Fiber",
    "markVerified": "Mark as verified",
    "verified": "verified",
    "settings": "Settings",
    "appleFee": "Apple fee (%)",
    "usdChf": "USD → CHF rate",
    "settingsHint": "Default 15% (Small Business Program). The rate converts AI costs to CHF.",
    "gross": "Gross",
    "net": "Net",
    "expiresOn": "expires on",
    "expiredOn": "expired on",
    "daysShort": "days",
    "noExpiry": "no expiry",
    "inviteUpgrade": "Invite",
    "inviteSent": "Pro upgrade invitation sent",
    "manualSet": "Manual",
    "sourcesHint": "Apple ✓ = paid via Apple and confirmed by receipt. Manual = Pro set without a payment source.",
    "expiringSoon": "Expiring in the next 14 days",
    "expiringNone": "No gifted Pro expires in the next 14 days.",
    "paidSubs": "Paid subscriptions",
    "unverifiedSubs": "Unconfirmed / manual",
    "unverifiedHint": "These Pro accesses are not backed by an Apple receipt.",
    "giftedSubs": "Gifted Pro accesses",
    "sortedByExpiry": "sorted by expiry",
    "revenueTitle": "Revenue / month",
    "revenueNoPrices": "Apple prices not configured (APPLE_PRICE_MONTHLY/_YEARLY)",
    "revenueMonthly": "monthly",
    "revenueYearly": "yearly",
    "revMonthlySubs": "Monthly plans",
    "revYearlySubs": "Yearly plans",
    "revPerMonth": "per month",
    "revPerYear": "per year (one-off)",
    "gifted": "Gifted",
    "aiLimitsSaved": "Limits saved",
    "tab_ai": "AI usage",
    "aiUsageTotals": "Whole app",
    "aiUsageCalls": "calls",
    "aiUsageEmpty": "No AI calls this month.",
    "grantAllBtn": "Gift free Pro to all existing users (one-time, for testers)",
    "grantAllConfirm": "Gift free Pro (🎁) to all existing users without Pro now?",
    "grantAllOk": "Pro gifted to {n} users 🎁",
    "compProTitle": "Free Pro",
    "compProActive": "Gifted — user has Pro for free",
    "compProPaid": "User has a paid subscription",
    "compProOff": "Unlock the full version for free",
    "compProGrant": "Gift Pro",
    "compProRevoke": "Revoke",
    "compProGrantedOk": "Pro gifted 🎁",
    "compProUntil": "Gifted until",
    "compProGrant3m": "3 months",
    "compProGrant1m": "1 month",
    "compProGranted1mOk": "Pro gifted for 1 month 🎁",
    "compProGrant12m": "1 year",
    "compProGrantUnlimited": "Unlimited",
    "compProGranted3mOk": "Pro gifted for 3 months 🎁",
    "compProGranted12mOk": "Pro gifted for 1 year 🎁",
    "compProRevokedOk": "Free Pro revoked",
    "tab_content": "Content",
    "tab_stats": "Statistics",
    "recipes": "Recipes",
    "foods": "Foods",
    "searchRecipes": "Search recipes…",
    "searchFoods": "Search foods (min. 2 chars for built-in DB)…",
    "noRecipes": "No recipes found.",
    "publish": "Publish",
    "unpublish": "Hide",
    "publishOk": "Recipe published",
    "unpublishOk": "Recipe hidden",
    "recipeDeletedOk": "Recipe deleted",
    "foodDeletedOk": "Entry deleted",
    "foodsLearned": "Learned foods",
    "foodsCustom": "Custom foods (users)",
    "bp": {
      "tab": "Taught",
      "hint": "Products users taught Solano by barcode (nutrition-label photo or manual entry). Verified products become authoritative for all users.",
      "search": "Search name, brand or barcode…",
      "toReview": "To review",
      "empty": "No taught products",
      "global": "Global",
      "fromLabel": "Label photo",
      "verify": "Verify",
      "unverify": "Verified",
      "verifiedOk": "Product verified – now applies to all users",
      "unverifiedOk": "Verification removed",
      "deletedOk": "Product deleted",
      "deleteTitle": "Delete product?",
      "deleteBody": "will be removed for all users. The next scan will report it as unknown again.",
      "editTitle": "Correct product",
      "brand": "Brand",
      "ingredients": "Ingredients",
      "markVerified": "Mark as verified (applies to all users)"
    },
    "foodsBuiltin": "Built-in database (view only)",
    "dailyActivity": "Activity (14 days): food logs & active users",
    "signups": "Signups per week",
    "total_recipes": "Recipes",
    "total_recipes_public": "Public recipes",
    "total_foods_learned": "Learned foods",
    "total_foods_custom": "Custom foods",
    "total_ai_photo_cache": "AI analyses (cache)",
    "total_food_logs_total": "Food logs total",
    "total_workouts_total": "Workouts total",
    "changeRole": "Role",
    "roleChangedOk": "Role changed",
    "title": "Admin area",
    "subtitle": "App management — super admin only",
    "navAdmin": "Admin",
    "tab_overview": "Overview",
    "mrr": "Revenue/month",
    "subsApple": "Apple",
    "subsWeb": "Web",
    "subsComp": "Gifted",
    "recentUsers": "Newest users",
    "seeAllUsers": "All users",
    "todayImportant": "Important today",
    "todayImportantEmpty": "All clear. Nothing to do.",
    "grpInactive": "{n} users inactive for 7+ days",
    "grpFading": "{n} users with fading activity",
    "grpOverKcal": "{n} users above calorie goal",
    "grpLowProtein": "{n} users below protein goal",
    "grpNewLogs": "{n} new diary entries today",
    "foodEntries": "Food entries",
    "logoutConfirmTitle": "Log out?",
    "logoutConfirmBody": "You will need to sign in again.",
    "tab_users": "Users",
    "tab_subs": "Subscriptions",
    "tab_reports": "Reports",
    "tab_moderation": "Moderation",
    "tab_audit": "Audit log",
    "statUsers": "Users",
    "statActive7d": "active (7d)",
    "statPendingOnboarding": "without onboarding",
    "statLogsToday": "Logs today",
    "todayLogsTitle": "Today's logs",
    "openProfile": "Open profile",
    "todayLogsEmpty": "No entries yet today",
    "activeUsersTitle": "Active in the last 7 days",
    "activeUsersEmpty": "No active users",
    "lastActive": "last active",
    "logs7d": "logs (7d)",
    "justNow": "just now",
    "inactiveChip": "Inactive 7d+",
    "inactiveTitle": "Inactive users",
    "inactiveHint": "No diary entry for 7+ days. Nudging sends a friendly reminder via push 🔔 (if enabled) and email ✉️.",
    "inactiveEmpty": "Everyone is active 🎉",
    "nudge": "Nudge",
    "nudgeAll": "Nudge all",
    "nudgeAllConfirm": "Nudge {n} users (push + email)?",
    "nudgeAllDone": "{n} users nudged",
    "nudgeSent": "Reminder sent",
    "nudgeNoChannel": "no channel (neither push nor email)",
    "nudgedOn": "nudged on",
    "neverLogged": "never logged",
    "daysInactive": "days inactive",
    "statSubs": "Subs",
    "statBlocked": "Blocked",
    "statReports": "reports",
    "searchUsers": "Search users (name or email)…",
    "last7days": "Last 7 days",
    "allLetters": "All",
    "country": "Country",
    "countryAll": "All countries",
    "countryUnknown": "Unknown",
    "signupsByCountry": "Sign-ups by country & week",
    "signupsByCountryHint": "last 8 weeks",
    "countryOther": "Other",
    "signupsNone": "No sign-ups yet",
    "proByCountry": "Pro subscriptions by country",
    "proByCountryHint": "all users · conversion = paid Pro / users",
    "proGifted": "Gifted",
    "proConversion": "Conv.",
    "filterActive": "Active",
    "filterBlocked": "Blocked",
    "noUsers": "No users found.",
    "role": "Role",
    "registered": "Registered",
    "plan": "Plan",
    "blocked": "Blocked",
    "linkedClients": "Linked clients",
    "weights": "Weights",
    "payments": "Payments",
    "block": "Block",
    "unblock": "Unblock",
    "delete": "Delete",
    "deleteConfirm": "Really delete?",
    "blockReasonPrompt": "Reason for blocking (optional):",
    "blockedOk": "User blocked",
    "unblockedOk": "User unblocked",
    "deletedOk": "User and all data deleted",
    "noSubs": "No subscribers yet.",
    "recentTx": "Recent transactions",
    "noReports": "No reports.",
    "noAudit": "No admin actions logged yet.",
    "viewTracking": "View tracking & details",
    "resetApple": "Reset Apple subscription",
    "resetAppleConfirm": "Remove the Apple subscription from our database? (Sandbox testing only — a real active subscription re-activates itself)",
    "resetAppleOk": "Apple subscription reset",
    "aiFeat": {
      "food_photo": "Food photo",
      "food_photo_hint": "Re-analysis (hint)",
      "fridge_photo": "Pantry photo",
      "workout_photo": "Workout import",
      "coach_chat": "AI coach",
      "pantry_recipe": "Pantry recipes",
      "weekly_menu": "Weekly menus",
      "social_caption": "Social captions"
    }
  },
  "notifBell": {
    "achievements": "Achievements",
    "levelUp": "Level {level} reached — “{name}”",
    "streak": "{days}-day streak! +{points} SP",
    "badge": "New badge: {name}",
    "goals": {
      "water_goal": "Water goal reached",
      "steps_goal": "Step goal reached",
      "sleep_7h": "7 h of sleep achieved",
      "diary_complete": "Diary complete (3+ meals)",
      "plate_check_80": "Balanced plate achieved"
    },
    "title": "Notifications",
    "empty": "No new notifications",
    "openFriends": "Open friends"
  },
  "offline": {
    "savedOffline": "No connection – meal saved on your device and will be sent automatically",
    "synced": "{count} meal(s) sent",
    "syncFailed": "{count} meal(s) could not be sent",
    "pendingTitle": "{count} meal(s) waiting for connection",
    "pendingHint": "They'll be added to your diary automatically as soon as you're back online.",
    "sendNow": "Send now",
    "stillOffline": "Still no connection – we'll keep trying",
    "waiting": "Waiting for connection"
  },
  "voicePrivacy": {
    "title": "What happens to my voice?",
    "pillNotStored": "Voice is not stored",
    "pillStored": "Voice note is stored",
    "introDictation": "Dictation only turns your voice into text.",
    "dict1": "The recording is transmitted encrypted and used solely to produce text. Only that text is saved – just as if you had typed it. You can review and edit it before saving.",
    "dict2": "The audio file is deleted immediately after transcription. It never reaches the database or any backup.",
    "dict3": "The microphone is only active while you deliberately record. No background listening.",
    "introStored": "This voice note is meant for your nutrition coach.",
    "msg1": "The recording is saved with the entry – like a chat message – so your coach can listen to it.",
    "msg2": "Only you and your connected coach can play it. It is not sent to an AI and not transcribed.",
    "msg3": "Delete it any time by replacing the reply, deleting the entry or deleting your account.",
    "never": "Voice, photos and chats are never used for AI training and never shared with ad networks.",
  },
  "dailySummary": {
    "sourceManual": "Manual",
    "pickTheme": "Choose style",
    "waterQuickTitle": "Add water",
    "waterCustomPlaceholder": "Enter ml…",
    "title": "Your day",
    "today": "Today",
    "sleep": "Sleep",
    "steps": "Steps",
    "water": "Water",
    "kcal": "Kcal",
    "workout": "Workout",
    "goals": "Goals",
    "missionsAllDone": "Missions complete! 🎉",
    "missionsAllDoneSub": "+{n} SP daily bonus",
    "download": "Download my day",
    "downloaded": "Image saved",
    "shareTitle": "My Solano day",
    "share": "Share",
    "longPressToSave": "Press and hold the image to save it to Photos",
    "previewHint": "Save the image or share it directly",
    "shareFailedHint": "Sharing failed – press and hold the image to save it",
    "mealsToday": "Today's meals",
    "noMeals": "No meals logged today",
    "pointsToday": "Today's points",
    "coachMessage": "Your coach says",
    "brand": "Your day in wellness",
    "defaultMotivation": "One day at a time. Small steps, big wins. 💪",
    "themeLabel": "Theme",
    "themes": {
      "bright_morning": "Bright morning",
      "golden_hour": "Golden hour",
      "deep_teal": "Deep teal",
      "berry_night": "Berry night"
    }
  },
  "diary": {
    "title": "Today's diary",
    "mealVerdictGood": "Great",
    "today": "Today",
    "yesterday": "Yesterday",
    "pctOfDay": "{n}% of daily target",
    "verdictExplainGood": "Great: well-balanced meal.",
    "verdictExplainWarn": "OK — small improvements possible:",
    "verdictExplainBad": "Needs work — over limits on:",
    "verdictReason": {
      "sugar": "Too much sugar (> 25 g)",
      "salt": "Too much salt (> 2.5 g)",
      "satFat": "Too much saturated fat (> 8 g)",
      "heavySnack": "Snack too calorific (> 350 kcal)",
      "balancedMain": "Balanced: protein + fiber + kcal on point",
      "lightSnack": "Light, well-balanced snack",
      "goodBreakfast": "Breakfast with good fiber/protein",
      "lowProtein": "Low protein — add lean protein",
      "lowFiber": "Low fiber — add vegetables or wholegrains",
      "tooLight": "A bit light for a main meal",
      "tooHeavy": "A bit heavy — reduce portions",
      "emptyCarbs": "Only carbs — add protein or fiber",
      "lowProteinOrFiber": "Low protein or fiber",
      "heavyBreakfast": "Breakfast a bit heavy",
      "neutral": "Neutral verdict"
    },
    "verdictAdvice": {
      "sugar": "Swap sugary drinks/desserts for fresh fruit. Try low-sugar recipes (< 8 g).",
      "salt": "Cut processed foods (deli meats, sauces, salty snacks). Look for recipes with < 1 g salt.",
      "satFat": "Use olive oil instead of butter or animal fats. Recipes with sat fat < 3 g.",
      "heavySnack": "Try snacks under 200 kcal (fruit, Greek yogurt, portioned nuts).",
      "lowProtein": "Add 100–150 g chicken, fish, eggs or legumes. Recipes with protein ≥ 25 g.",
      "lowFiber": "Add raw/cooked veggies, legumes or wholegrains. Recipes with fiber ≥ 8 g.",
      "tooLight": "Recipes 400–700 kcal will keep you full until the next meal.",
      "tooHeavy": "Reduce carb & fat portions. Balanced recipes ≤ 550 kcal.",
      "emptyCarbs": "Balance with protein (yogurt, eggs) or fiber (veggies, fruit).",
      "lowProteinOrFiber": "Add lean protein OR fiber to balance the meal.",
      "heavyBreakfast": "Breakfast ≤ 450 kcal: fruit + Greek yogurt + wholegrain oats."
    },
    "verdictSheetPraise": "Great job — this meal is well balanced for your goals.",
    "verdictRecipesSuggest": "Recipes that can help",
    "verdictNoRecipes": "No matching recipe in your library yet. Try a new one from the Fridge!",
    "mealVerdictWarn": "Good",
    "mealVerdictBad": "Improve",
    "subtitle": "Log what you eat.",
    "newCommentOne": "1 new comment",
    "newCommentMany": "{count} new comments",
    "newCommentTap": "Tap to see the feedback",
    "logAsMeal": "Log as today's meal",
    "addToDiary": "Add to diary",
    "totalEst": "Daily total:",
    "addMeal": "Add meal",
    "addMealHint": "Pick how you want to log this meal",
    "quickManual": "Manual",
    "quickPhoto": "AI Photo",
    "quickFood": "Food",
    "quickVoice": "Voice",
    "quickSearch": "Find food",
    "typeLabel": "Type",
    "descLabel": "Description",
    "kcalOpt": "Kcal (opt.)",
    "descPh": "e.g. 80g wholewheat pasta, tomato, olive oil",
    "notesPh": "Notes (hunger, mood, sport…)",
    "logMealBtn": "Log meal",
    "mealLogged": "Meal logged",
    "sharedToLibrary": "Shared in the recipe library",
    "describe": "Describe what you ate",
    "noneForDate": "No meals logged on this date.",
    "saveAsRecipe": "Save as recipe",
    "saveAsRecipeHint": "{n} entries · {kcal} kcal total. Save this dish as your own recipe — next time just log one portion.",
    "recipeNamePh": "Recipe name (e.g. Grandma's lasagna)",
    "recipeNameRequired": "Please enter a recipe name.",
    "recipeServings": "Makes servings",
    "recipePerServing": "≈ {kcal} kcal per serving",
    "recipeNotePh": "Preparation / notes (optional)",
    "recipeUsePhoto": "Use the photo from the entry",
    "recipePhotoAuto": "This photo is used as the recipe image automatically",
    "recipeSaveBtn": "Save recipe",
    "recipeSaved": "Recipe saved! Find it in the \"Recipes\" tab when logging 📖",
    "autoSortedInto": "Sorted into:",
    "recipeKeepMyPortion": "Keep only my portion in the diary",
    "recipeMyPortions": "My portions",
    "recipeMyPortionHint": "The entries are replaced by 1 entry with ≈ {kcal} kcal",
    "recipeSavedPortion": "Recipe saved — your diary now shows only your portion 📖",
    "breakfast": "breakfast",
    "snack": "snack",
    "lunch": "lunch",
    "afternoon": "afternoon snack",
    "dinner": "dinner",
    "aiPhoto": "Analyze with AI",
    "aiPhotoDesc": "Take a photo of your dish: the AI will recognize the foods and compute kcal, macros and micronutrients.",
    "openCamera": "Open camera",
    "uploadPhoto": "Upload photo",
    "portionTipTitle": "Tip for a better portion estimate",
    "portionTipBody": "Include a hand, a fork or a coin in the photo — it helps the AI estimate grams more accurately.",
    "portionUncertain": "The AI isn't sure about the portion sizes — please check and adjust the grams before saving.",
    "portionTipDismiss": "Got it",
    "aiAnalyzing": "Analyzing…",
    "aiOk": "Meal recognized! Adjust if needed, then log.",
    "aiError": "Could not analyze the photo. Try again or enter manually.",
    "wrongMatch": "Wrong match?",
    "wrongMatchAria": "Report a wrong match",
    "wrongMatchPrompt": "What should this food be called?",
    "wrongMatchOk": "Thanks! Correction saved — we'll learn from it.",
    "wrongMatchError": "Couldn't send the correction. Try again?",
    "recognizedFoods": "Recognized foods",
    "addFood": "Add food",
    "foodNamePh": "e.g. Grilled zucchini",
    "recompute": "Recompute macros",
    "recomputing": "Recomputing…",
    "recomputeOk": "Macros recomputed",
    "foodNotRecognized": "Not recognized (0 kcal)",
    "foodPickFromDb": "pick from database",
    "recomputeError": "Could not recompute — check names/weights",
    "confirmDelete": "Delete this meal?",
    "deleted": "Meal deleted",
    "undo": "Undo",
    "restored": "Delete undone",
    "duplicateFromYesterday": "Copy from yesterday",
    "yourMeals": "Your meals",
    "yourMealsSubtitle": "Meals & ingredients from the last 7 days – tap to copy",
    "favorites": "Favorites",
    "favoriteAdd": "Mark as favorite",
    "favoriteRemove": "Remove favorite",
    "favoriteAdded": "Added to favorites",
    "favoriteRemoved": "Removed from favorites",
    "favLongPressHint": "Long-press = log instantly",
    "favQuickLogged": "Favorite logged instantly",
    "noMealsYesterday": "No meals logged yesterday",
    "mealDuplicated": "Meal copied to today",
    "mealUpdated": "Meal updated",
    "editMeal": "Edit meal",
    "hintLabel": "Help the AI",
    "hintOptional": "(optional)",
    "hintPlaceholder": "e.g. 35g flour, 80g egg, 80g banana",
    "hintCompute": "Compute nutrition",
    "photoAttached": "Photo added",
    "quickEntryLabel": "Quick entry",
    "hintComputed": "Nutrition computed from your list",
    "hintComputedPartial": "{matched} of {total} ingredients recognised — values may be incomplete",
    "splitIngredients": "Split into ingredients",
    "splitIngredientsHint": "Edit each ingredient separately – macros estimated by gram share (≈), totals unchanged",
    "splitDone": "{n} ingredients created",
    "lookupIngredients": "Use nutrition facts from database",
    "lookupIngredientsHint": "Replaces the estimated (≈) values with real per-100 g nutrition facts",
    "lookupRow": "From database",
    "lookupDone": "{n} ingredients taken from the database",
    "lookupPartial": "{found} of {total} ingredients found – the rest stays estimated",
    "hintReanalyze": "Re-analyse with hint",
    "hintReanalyzed": "Analysis updated with your hint",
    "aiRetryTitle": "Photo analysis failed",
    "aiRetryHelp": "Add a hint below to help the AI, or just retry now.",
    "aiRetryBtn": "Retry",
    "aiChefStep1": "Analysing your meal…",
    "aiChefStep2": "Recognising the foods…",
    "aiChefStep3": "Calculating calories and macros…",
    "aiChefStep4": "Almost done…",
    "aiChefStep5": "Your meal is almost ready…",
    "aiChefDone": "Your meal is ready.",
    "barcodeNudgeTitle": "Packaged product detected",
    "barcodeNudgeBody": "Scan the barcode for exact label values",
    "barcodeNudgeCta": "Scan →",
    "journalTitle": "Today's journal",
    "journalSubtitle": "How do you feel? How did today go?",
    "journalPlaceholder": "Free notes on your day, workout, energy, cravings…",
    "journalSaving": "Saving…",
    "journalSaved": "Saved",
    "journalVoiceRec": "Recording",
    "journalVoiceTranscribing": "Transcribing…",
    "journalVoiceEmpty": "No speech detected",
    "journalVoicePermDenied": "Microphone permission denied",
    "journalReplies": "Nutritionist replies",
    "journalSaveEntry": "Save entry",
    "journalTodayEntries": "Today's entries",
    "journalMorning": "Morning",
    "journalAfternoon": "Afternoon",
    "journalEvening": "Evening",
    "journalPickSomething": "Pick a mood or type something",
    "duplicateAll": "Copy all",
    "swipeEdit": "Edit",
    "swipeDuplicate": "Duplicate",
    "swipeDelete": "Delete",
    "allDuplicated": "{n} meals copied",
    "meal": "Meal",
    "portionLabel": "Portion",
    "portionHint": "Adjust grams: macros will scale",
    "notesTitle": "Instructions and notes",
    "save": "Save",
    "voiceTap": "Tap to speak",
    "voiceListening": "Listening…",
    "voiceAnalyzing": "Analyzing what you said…",
    "voiceListeningHint": "Describe your meal out loud. Tap «Stop» when done.",
    "voiceAnalyzingHint": "One moment, transcribing…",
    "voiceStop": "Stop",
    "voiceOk": "Done! Adjust if needed, then save.",
    "voiceError": "I didn't get it, try again",
    "voicePermDenied": "Microphone permission needed",
    "transcript": "Transcript",
    "selectMealType": "Meal type",
    "chooseDateTime": "Date & time",
    "summaryTitle": "Meal summary",
    "kcalShort": "kcal",
    "proteinShort": "Prot.",
    "carbsShort": "Carbs",
    "fatShort": "Fat",
    "fiberShort": "Fiber",
    "voiceNoteMax": "Record voice note (max 15s)"
  },
  "food": {
    "gramsTab": "Grams",
    "pieces": "Pieces",
    "sizeSmall": "small",
    "sizeMedium": "medium",
    "sizeLarge": "large",
    "barcodeNotFoundAddManually": "Product not found — add it manually",
    "torch": "Torch",
    "pinchZoomHint": "Pinch with two fingers to zoom.",
    "title": "Find food",
    "description": "Search by name or scan a product barcode",
    "recipeIngredients": "Ingredients",
    "recipeSteps": "Preparation",
    "portion": "portion",
    "servings": "servings",
    "servingsN": "{n} servings",
    "byName": "Name",
    "byBarcode": "Barcode",
    "searchPh": "banana, whole-wheat pasta, greek yogurt…",
    "scanWithCamera": "Scan with camera",
    "or": "or",
    "aimAtBarcode": "Point the camera at the product barcode",
    "scannerFocusHint": "If it won't read, tap the barcode to focus.",
    "zoom": "Zoom",
    "labelOcrTitle": "Barcode unreadable?",
    "labelOcrBody": "Take a photo of the nutrition label — AI reads the values",
    "labelOcrCameraCta": "Take photo",
    "labelOcrGalleryCta": "Gallery",
    "labelUnreadable": "Label unreadable, try again with better light",
    "labelError": "Label read failed",
    "labelProduct": "Product from label",
    "pointBarcode": "Point the camera at the product barcode",
    "startingCamera": "Starting camera…",
    "orEnterManually": "Or enter the code manually:",
    "enterCode": "Enter code",
    "rescan": "Scan again",
    "camPermission": "Camera permission needed",
    "camError": "Cannot open the camera",
    "camNoStream": "Camera won't start. Use a photo from your gallery or type the code.",
    "camNodevice": "No camera found",
    "camGeneric": "Camera unavailable",
    "pickPhoto": "Snap or pick photo",
    "noBarcodeInImage": "No barcode detected in the photo",
    "camNoDevice": "No camera detected",
    "camBusy": "The camera is already in use by another app",
    "camIframe": "Camera is blocked by preview. Open the app in a new tab ↗",
    "camTip": "Tip: tap the ↗ icon at the top to open the app outside the preview and grant permission.",
    "camTipNative": "Tip: allow camera access under Settings → Apps → Solano Essence → Permissions → Camera, then try again.",
    "notFound": "Product not found",
    "manualAdd": {
      "title": "Add this product manually",
      "subtitle": "This barcode isn't in the database yet — save it once and next scan will resolve instantly.",
      "barcode": "EAN code",
      "name": "Product name",
      "namePlaceholder": "e.g. Plain Greek yogurt",
      "brand": "Brand (optional)",
      "brandPlaceholder": "e.g. FAGE",
      "per100g": "Values per 100 g",
      "kcal": "Calories",
      "protein": "Protein",
      "carbs": "Carbs",
      "fat": "Fat",
      "sugar": "Sugar",
      "fiber": "Fiber",
      "satFat": "Sat. fat",
      "salt": "Salt",
      "hint": "Copy the values from the nutrition label. You can leave blank the fields you don't need.",
      "saveAndUse": "Save & use",
      "saved": "Product saved ✓",
      "needBasics": "Name and barcode are required",
      "labelAiTitle": "Fill with AI ✨",
      "labelAiSubtitle": "Photograph the nutrition label — AI reads kcal and macros and fills the form for you.",
      "labelCamera": "Take photo",
      "labelUpload": "Upload photo",
      "labelAnalyzing": "AI is reading the label…",
      "labelAnalyzed": "Label read ✓ — please double-check",
      "labelError": "Couldn't read the label. Try a sharper photo.",
      "productPhoto": "Product photo",
      "productPhotoAdd": "Add photo",
      "productPhotoRetake": "Retake photo"
    },
    "searchError": "Search error",
    "backToResults": "Back",
    "nameSaved": "Product name saved — future scans will show it",
    "quantityConsumed": "Quantity consumed",
    "yourPortion": "Your portion",
    "sugar": "Sugar",
    "fiber": "Fibre",
    "satFat": "Sat. fat",
    "salt": "Salt",
    "ofCarbs": "of which",
    "ofFat": "of which",
    "lightSugarShort": "Su",
    "lightFatShort": "Fa",
    "lightSaltShort": "Sa",
    "altTitle": "Healthier alternative?",
    "altCta": "3 suggestions",
    "altEmpty": "No suitable green alternative found.",
    "lightLow": "low",
    "lightMid": "medium",
    "lightHigh": "high",
    "lightBasis": "per 100 g",
    "noDetails": "No data on sugar, fibre, saturated fat and salt for this product.",
    "addToMeal": "Add to meal",
    "tabDb": "Solano Database",
    "tabFav": "Favorites",
    "tabCustom": "My data",
    "tabRecipes": "Recipes",
    "tabRecent": "Recent",
    "noRecentYet": "No recent foods yet. Add your first meal!",
    "per100g": "per 100 g",
    "perPortion": "per portion",
    "addToFav": "Add to favorites",
    "removeFav": "Remove from favorites",
    "favAdded": "Added to favorites",
    "favRemoved": "Removed from favorites",
    "noFavYet": "No favorites yet. Tap the heart on a food to save it.",
    "noCustomYet": "No custom foods yet. Create your first one.",
    "noRecipesYet": "No recipes found.",
    "createCustom": "New food",
    "editCustom": "Edit food",
    "customName": "Name",
    "customBrand": "Brand (opt.)",
    "customNotes": "Notes (opt.)",
    "customKcal": "Kcal / 100 g",
    "customProtein": "Protein / 100 g",
    "customCarbs": "Carbs / 100 g",
    "customFat": "Fat / 100 g",
    "customSugar": "Sugar / 100 g",
    "customFiber": "Fiber / 100 g",
    "customSat": "Sat. fat / 100 g",
    "customSalt": "Salt / 100 g",
    "save": "Save",
    "cancel": "Cancel",
    "customCreated": "Food created",
    "customDeleted": "Food deleted",
    "deleteConfirm": "Delete this food?",
    "detailBadge": "DETAIL",
    "minLettersHint": "Type at least 2 letters to search the database.",
    "aiBadge": "AI ESTIMATE",
    "aiEstimateTip": "Nutrition values estimated by AI: please verify before saving.",
    "searchInDbCta": "Search \"{q}\" in the Solano database"
  },
  "calc": {
    "title": "Calorie & macro calculator",
    "subtitle": "Based on your data I estimate your daily needs.",
    "ctaTitle": "Don't know how many kcal you need?",
    "ctaHint": "Automatic calculation tailored to you",
    "gender": "Sex",
    "genderM": "Male",
    "genderF": "Female",
    "age": "Age",
    "height": "Height",
    "weight": "Weight",
    "targetWeight": "Target weight",
    "targetWeightHint": "Optional · shows up in Progress with ETA projection",
    "activity": "Activity level",
    "actSedentary": "Sedentary",
    "actLight": "Light",
    "actModerate": "Moderate",
    "actIntense": "Intense",
    "actAthlete": "Athlete",
    "goal": "Goal",
    "goalCut": "Cut",
    "goalMaintain": "Maintain",
    "goalPerf": "Performance",
    "goalBulk": "Bulk",
    "calculate": "Calculate",
    "recalculate": "Recalculate",
    "applyToProfile": "Apply",
    "applied": "Targets saved to your profile",
    "missing": "Fill all fields",
    "customAdj": "Adjust deficit/surplus individually",
    "customAdjHint": "Drag to change the percentage relative to maintenance (-30% deficit ↔ +30% surplus).",
    "manualLink": "Already know your calorie target? Enter it manually",
    "maintenance": "Maintenance calories",
    "goalLabel": "Goal",
    "recommended": "Recommended daily target",
    "applyComputed": "Apply calculated target",
    "adjustManually": "Adjust manually",
    "macrosSum": "Macros total: {sum}%",
    "sumHint": "Total: {sum}% — please adjust to 100%",
    "jobTitle": "Job & everyday life",
    "jobSitting": "Mostly sitting (office, home office)",
    "jobStanding": "Standing / mixed (retail, teaching)",
    "jobPhysical": "Physically active (trades, care work)",
    "stepsTitle": "Steps per day",
    "trainTitle": "Workouts per week",
    "factorLabel": "Activity factor",
    "deficitTitle": "Weight-loss pace",
    "deficitSoft": "Gentle",
    "deficitModerate": "Moderate",
    "deficitFast": "Fast",
    "deficitCustom": "Custom",
    "goalCustom": "Custom",
    "etaWeeks": "≈ {weeks} weeks to {target} kg",
    "etaNote": "Just an estimate — your target weight does not affect the calorie calculation.",
    "dblCountHint": "Your training is already included in the activity factor — workout calories are not added on top of your daily budget.",
    "reviewTitle": "Goal check",
    "reviewBody": "Over the last {days} days: {actual} kg/week (planned: {expected} kg/week).",
    "reviewSuggestDown": "Suggestion: lower your daily target by 100 kcal to {kcal} kcal.",
    "reviewSuggestUp": "Suggestion: raise your daily target by 100 kcal to {kcal} kcal.",
    "reviewApply": "Apply",
    "reviewLater": "Later",
    "reviewApplied": "New daily target saved",
    "recompute": "Recompute with new values",
    "yourNeeds": "Your daily needs",
    "day": "day",
    "adjustment": "Adjustment"
  },
  "nutriPlan": {
    "buttonShort": "Plan",
    "title": "Nutrition plan",
    "subtitle": "Set daily targets for",
    "client": "Client",
    "selfLabel": "you",
    "historyTitle": "Goal history",
    "byCoach": "Coach",
    "bySelf": "You",
    "modeAuto": "Auto compute",
    "modeManual": "Manual",
    "autoTitle": "Compute with Mifflin-St Jeor",
    "formulaTitle": "BMR formula",
    "fMifflin": "Mifflin-St Jeor",
    "fMifflinHint": "Recommended · general adults",
    "fHarris": "Harris-Benedict",
    "fHarrisHint": "Rev. 1984 · classic",
    "fKatch": "Katch-McArdle",
    "fKatchHint": "Needs body fat %",
    "fCunningham": "Cunningham",
    "fCunninghamHint": "Athletes · body fat %",
    "bodyFat": "Body fat %",
    "bodyFatHint": "3–60% · required for Katch/Cunningham",
    "needBodyFat": "Enter body fat % (3–60)",
    "fallbackToMifflin": "Missing body fat % → using Mifflin-St Jeor",
    "customAdj": "Manual kcal adjustment",
    "customAdjHint": "Override the preset (-30% deficit ↔ +30% surplus)",
    "calculate": "Compute macros",
    "calcDone": "Values updated — edit if needed",
    "presetTitle": "Macro split",
    "presetBalanced": "Balanced",
    "presetLowCarb": "Low Carb",
    "presetHighProt": "High Protein",
    "presetCustom": "Custom",
    "needKcalForPreset": "Enter kcal first",
    "targetsTitle": "Daily targets",
    "fiber": "Fibre",
    "water": "Water",
    "microsTitle": "Micronutrients",
    "optional": "optional",
    "sodium": "Sodium",
    "calcium": "Calcium",
    "iron": "Iron",
    "vitD": "Vitamin D",
    "notifyLabel": "Notify the client",
    "notifyHint": "They will get a push with the new values",
    "saveAndActivate": "Save & activate",
    "saved": "Plan saved",
    "savedPushed": "Plan saved · client notified",
    "invalidKcal": "Kcal must be 800..6000",
    "macroSumWarn": "Macro sum: {sum}% (check the values)"
  },
  "supplements": {
    "title": "Supplement reminders",
    "atTime": "at {time}",
    "moreCount": "{n} more",
    "subtitleEmpty": "Tap to add",
    "addBtn": "Add supplement",
    "newTitle": "New supplement",
    "editTitle": "Edit",
    "presetsLabel": "Presets",
    "nameLabel": "Name",
    "namePlaceholder": "e.g. Magnesium 400mg",
    "timeLabel": "Time",
    "daysLabel": "Days",
    "everyDay": "Every day",
    "weekdays": "Mon-Fri",
    "weekend": "Weekend",
    "active": "active",
    "needName": "Name is required",
    "needDay": "Pick at least one day",
    "saved": "Saved",
    "confirmDelete": "Remove this reminder?",
    "emptyState": "No supplements yet. Add the first one!",
    "streakDays": "days",
    "takenToday": "Taken today",
    "markTakenToday": "Mark as taken today",
    "d": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    }
  },
  "apptsCli": {
    "title": "Appointments",
    "subtitle": "Request a consult with your nutritionist.",
    "newRequest": "New request",
    "typeLabel": "Type",
    "modalityLabel": "Modality",
    "firstVisit": "First visit",
    "checkup": "Check-up",
    "sportsConsult": "Sports consult",
    "inOffice": "In office",
    "video": "Video call",
    "notesPh": "Notes for the nutritionist (optional)",
    "sendRequest": "Send request",
    "sentOk": "Request sent! The nutritionist will confirm.",
    "yourBookings": "Your bookings",
    "empty": "No appointments.",
    "noNutTitle": "Link a nutritionist first",
    "noNutDesc": "To request a consult, enter your nutritionist's invite code on your profile page.",
    "goLinkNut": "Go to profile"
  },
  "profile": {
    "title": "My profile",
    "subtitle": "Keep your data up to date for a more precise plan.",
    "notifTitle": "Push notifications",
    "notifTapToOpen": "Tap to manage reminders",
    "devicesTapToOpen": "Tap to connect devices",
    "sectionSettings": "Settings",
    "sectionConnections": "Connections",
    "sectionAccount": "Account",
    "proActiveHint": "Pro is active — manage subscription",
    "proUpsellHint": "Unlock more possibilities for your daily routine",
    "proQuotaLeft": "left",
    "personalDataTitle": "Personal data",
    "languageTitle": "Language",
    "languageHint": "App language — independent of your device settings",
    "widgetSyncTitle": "Refresh widget now",
    "widgetSyncHelp": "Pushes today's values to the home-screen widgets",
    "widgetSyncOk": "Widget updated ✓ {kcal} kcal · {water} · {steps} steps",
    "widgetSyncFail": "Widget sync failed",
    "linkNutTitle": "Your nutritionist",
    "linkNutNone": "You are not linked to a nutritionist yet. Enter their invite code when you have it.",
    "linkNutLabel": "Nutritionist invite code",
    "linkNutBtn": "Link",
    "linkNutOk": "Nutritionist linked!",
    "linkedTo": "You are linked to:",
    "fullName": "Full name",
    "birthdate": "Date of birth",
    "gender": "Gender",
    "height": "Height (cm)",
    "startingWeight": "Starting weight (kg)",
    "kcalTarget": "Kcal target",
    "goal": "Goal",
    "activity": "Activity level",
    "sport": "Sport practised",
    "sportPh": "e.g. running, football, gym...",
    "allergies": "Allergies / intolerances",
    "medical": "Medical notes",
    "saveBtn": "Save profile",
    "updated": "Profile updated",
    "trainingDays": "Training days",
    "trainingDaysHelp": "Which weekdays do you usually train? Adapts your daily movement mission.",
    "notifEnableCta": "Enable push notifications on this device",
    "notifTz": "Time zone",
    "notifMeals": "Meal reminders",
    "notifWater": "Water reminders",
    "notifEveryMin": "Every (min)",
    "notifHelper": "Turn on reminders for meals and water. You'll get a notification on your phone at the times you set.",
    "notifActive": "active",
    "notifDenied": "Permission blocked: enable it in your browser settings.",
    "notifUnsupported": "Push not supported on this device.",
    "notifOk": "Push enabled ✓",
    "notifTestCta": "Send test notification",
    "notifTestSent": "Test notification sent ✓",
    "notifTestFail": "No notification sent. Try enabling push again.",
    "notifResetCta": "Reset & re-subscribe",
    "notifResetOk": "Subscription refreshed ✓",
    "notifResetFail": "Reset failed. Remove the PWA from the Home screen and reinstall it.",
    "notifWaterFrom": "From",
    "notifWaterTo": "To",
    "notifWaterFreq": "Every",
    "notifEvening": "Evening recap",
    "notifTraining": "Training reminder",
    "notifPlan": "Morning plan reminder",
    "notifPlanHint": "On days a workout plan is scheduled: “Today: Leg day – ready?” – one tap starts the workout.",
    "notifTrainingAt": "At",
    "notifTrainingHint": "Only sent on your planned training days — if you haven't already logged a workout that day.",
    "notifEveningAt": "At",
    "notifEveningPreview": "Preview",
    "notifEveningSendNow": "Send now",
    "mealBreakfast": "Breakfast",
    "mealSnack": "Snack",
    "mealLunch": "Lunch",
    "mealAfternoon": "Afternoon snack",
    "mealDinner": "Dinner",
    "female": "Female",
    "male": "Male",
    "other": "Other",
    "weightLoss": "Weight loss",
    "maintenance": "Maintenance",
    "muscle": "Muscle gain",
    "performance": "Sports performance",
    "sedentary": "Sedentary",
    "light": "Light",
    "moderate": "Moderate",
    "intense": "Intense",
    "athlete": "Athlete"
  },
  "language": {
    "label": "Language",
    "it": "Italiano",
    "en": "English",
    "de": "Deutsch"
  },
  "eveningTip": {
    "pageTitle": "Your evening tip",
    "pageSubtitle": "A small step now, a big win tomorrow",
    "hero": {
      "suggestion": "Tonight's suggestion",
      "fallback": "Keep taking care of your nutrition"
    },
    "stats": {
      "today": "Today",
      "kcal": "kcal",
      "dayStreak": "day streak"
    },
    "howto": "How to do it, made simple",
    "ctaSeeProgress": "See your progress",
    "ctaLogMeal": "Log a meal",
    "ctaLogWater": "Log water",
    "ctaFindRecipe": "Find a protein-rich recipe",
    "ctaAddSnack": "Add a snack",
    "ctaSeeSteps": "See steps & activity",
    "backHome": "Back to home",
    "bullets": {
      "long_streak": "Check your weekly curve in Progress|Treat yourself to a small reward – you earned it|Set your next 7-day goal",
      "no_dinner": "Open the diary and log your dinner|Even a light plate counts|Only logged meals count towards your balance and streak",
      "water_low": "Have 1 glass now and 1 before bed|Keep a bottle on the nightstand|Start tomorrow with 1 glass before coffee",
      "protein_gap": "Greek yogurt or skyr at breakfast|Boiled eggs as a snack|Add tuna or turkey slices at lunch",
      "kcal_deficit_large": "Greek yogurt with honey and nuts|A slice of whole-grain toast with avocado|Fruit + a handful of almonds",
      "steps_low": "Take a 20-minute walk after dinner|Get off one stop earlier|Take the stairs instead of the lift",
      "great_day": "Keep it up tomorrow|Prep tomorrow's breakfast tonight|Set a new weekly goal",
      "day_recap": "Review today's balance in Progress|Put a water bottle out for the morning|Plan tomorrow's breakfast ahead"
    }
  },
  "theme": {
    "title": "Appearance",
    "subtitle": "Choose how you want the app to look.",
    "light": "Light",
    "dark": "Dark",
    "system": "System",
    "systemHint": "Follows device settings"
  },
  "nutProfile": {
    "title": "Profile",
    "subtitle": "Manage account and appearance.",
    "accountTitle": "Account",
    "fullName": "Full name",
    "email": "Email",
    "emailReadOnly": "Email cannot be changed",
    "inviteTitle": "Practice invite code",
    "inviteHelp": "Share this code with new clients to link them to your practice."
  },
  "trend": {
    "last7days": "Last 7 days"
  },
  "aiCoach": {
    "title": "AI Coach",
    "chipLabel": "Coach",
    "chipSub": "{n} new tips",
    "chipReady": "Ready",
    "subtitle": "Today's tips for you",
    "refresh": "Refresh",
    "refreshed": "Tips updated",
    "stripHint": "Tap to see today's {count} tips",
    "askBtn": "Ask the Coach",
    "chatTitle": "Ask the AI Coach",
    "voiceOn": "Enable voice – answers are read aloud",
    "voiceOff": "Disable voice",
    "chatHint": "The coach knows your data: macros, scores, plate, sleep, weight, streaks. Attach a photo or screenshot.",
    "suggestionsLabel": "Try asking:",
    "inputPlaceholder": "Type a question…",
    "thinking": "Coach is thinking…",
    "send": "Send",
    "attachPhoto": "Attach a photo",
    "takePhoto": "Take a photo",
    "fromGallery": "Photo/screenshot from gallery",
    "photoReady": "Photo ready to send",
    "startRec": "Record a voice message",
    "stopRec": "Stop recording",
    "recording": "Recording… tap the mic to stop",
    "transcribing": "Transcribing your voice…",
    "transcribeError": "I couldn't understand, try speaking more clearly",
    "micUnsupported": "Microphone is not supported on this device",
    "micDenied": "Microphone permission denied"
  },
  "restaurant": {
    "title": "At the restaurant",
    "subtitle": "Let AI read the menu and pick the best dish for you",
    "badgeNew": "NEW",
    "tabPhoto": "Menu photo",
    "tabText": "Type the menu",
    "captureBtn": "Take photo",
    "chooseFileBtn": "From device",
    "captureHint": "Open camera",
    "chooseFileHint": "From your gallery",
    "imageSelected": "Image selected",
    "analyzeBtnNow": "Analyze now",
    "infoTitle": "AI analyzes for you:",
    "infoProtein": "Protein",
    "infoVeg": "Veggies",
    "infoKcal": "Calories",
    "infoCarbs": "Carbs",
    "infoFat": "Fat",
    "infoBest": "Best pick",
    "step1": "Take or upload",
    "step2": "AI analyzes",
    "step3": "Get advice",
    "photoHint": "Frame the restaurant menu, then tap Analyze",
    "textPlaceholder": "Enter a restaurant name OR list dishes (e.g. “Hooters Interlaken” or “pasta, sole, tiramisu”)…",
    "recentSearches": "Recent searches",
    "removeRecent": "Remove",
    "analyzeBtn": "Analyze the menu",
    "analyzing": "Analyzing…",
    "retakeBtn": "New photo",
    "changeMenuBtn": "Change menu",
    "mealLabel": "Meal",
    "meals": {
      "colazione": "Breakfast",
      "pranzo": "Lunch",
      "merenda": "Snack",
      "cena": "Dinner",
      "spuntino": "Snack"
    },
    "budgetTitle": "Left for today",
    "budgetKcal": "kcal",
    "budgetProtein": "Protein",
    "budgetCarbs": "Carbs",
    "budgetFat": "Fat",
    "medScore": "Med score",
    "noBudget": "No target set — enable it in profile for tighter advice",
    "resultsTitle": "Recommended picks",
    "chooseBtn": "I'll pick this",
    "choosingIn": "Adding to diary…",
    "addedToDiary": "Dish added to diary 🍽️",
    "addError": "Couldn't add to diary",
    "analyzeError": "Couldn't analyze the menu. Try again.",
    "needInput": "Provide a menu photo or type the dishes",
    "tipsTitle": "Extra tips",
    "verdictGreen": "Great pick",
    "verdictYellow": "OK with care",
    "verdictRed": "Better skip",
    "medImpact": {
      "positive": "↑ Med",
      "neutral": "= Med",
      "negative": "↓ Med"
    },
    "backBtn": "Back to dashboard",
    "historyTitle": "Your restaurant favourites",
    "removeFavorite": "Remove from favorites",
    "favoriteRemoved": "Removed from favorites",
    "reorderBtn": "Reorder"
  },
  "pantry": {
    "title": "Pantry",
    "subtitle": "What you have at home",
    "empty": "Your pantry is empty. Add items or scan a receipt.",
    "addManual": "Add manually",
    "namePlaceholder": "e.g. Eggs, tomatoes, Greek yogurt…",
    "qtyPlaceholder": "Qty",
    "added": "Added to pantry",
    "deducted": {
      "some": "-{g} of {name} · {after} left",
      "depleted": "{name} used up — remove from pantry",
      "restored": "Restored {name}"
    },
    "scanReceipt": "Scan receipt",
    "scanReceiptHint": "AI reads the items",
    "scanEan": "Scan EAN",
    "scanEanHint": "One product at a time",
    "itemAdded": "Added to pantry",
    "needName": "Name required",
    "scanError": "Couldn't read the receipt",
    "scanning": "Reading receipt…",
    "whatToCook": "What to cook?",
    "whatToCookHint": "Recipe with what you have",
    "needMore": "Add at least 2 ingredients",
    "recipeCreated": "Recipe created!",
    "receiptTitle": "Review receipt items",
    "receiptDesc": "Uncheck what you don't want to save and fix names/quantities as needed.",
    "receiptAdded": "{count} items added to pantry",
    "receiptEmpty": "No items recognized",
    "addAll": "Add all",
    "emptyShort": "Empty — tap to fill",
    "countShort": "{count} ingredients at home",
    "expiryLabel": "Expiry",
    "autoSuggested": "AUTO",
    "useSoonTitle": "Use up first",
    "rest": "Rest of pantry",
    "allItems": "All products",
    "mergedToast": "{name}: {qty}",
    "storageLabel": "Where to store",
    "storage": {
      "fridge": "Fridge",
      "pantry": "Pantry",
      "freezer": "Freezer"
    },
    "expired": "Expired {days}d ago",
    "today": "Expires today",
    "inDays": "In {days}d",
    "notifTitle": "Expiry alert",
    "notifBodyOne": "{name} expires tomorrow. Use it today.",
    "notifBodyMany": "{count} items are about to expire (e.g. {name}).",
    "categoryLabel": "Category",
    "categoryHint": "Change category",
    "cat_fruit": "Fruit",
    "cat_vegetables": "Vegetables",
    "cat_dairy": "Dairy",
    "cat_meat": "Meat",
    "cat_fish": "Fish",
    "cat_eggs": "Eggs",
    "cat_grains": "Grains & Pasta",
    "cat_legumes": "Legumes",
    "cat_oils_fats": "Oils & Fats",
    "cat_spices_condiments": "Spices & Condiments",
    "cat_sweets": "Sweets",
    "cat_beverages": "Beverages",
    "cat_frozen": "Frozen",
    "cat_supplements": "Proteins & Supplements",
    "cat_other": "Other",
    "searchPlaceholder": "Search your pantry…",
    "stats": {
      "products": "Items",
      "categories": "Categories",
      "expiring": "Expiring",
      "shopping": "Shopping list"
    },
    "shoppingEmptyHappy": "🎉 All bought!",
    "shoppingEmptyHint": "Time for new recipes.",
    "expiryChip": {
      "fresh": "Fresh",
      "soon": "Expiring",
      "today": "Today",
      "expired": "Expired"
    },
    "filter": {
      "expiringOnly": "Only expiring items",
      "all": "All",
      "fresh": "Fresh",
      "soon": "Expiring",
      "expired": "Expired",
      "favorites": "Favorites",
      "healthy": "A/B only"
    },
    "swap": {
      "title": "Healthier alternatives",
      "subtitle": "{n} items with low Nutri-Score",
      "added": "{name} added to list",
      "dismiss": "That's fine for me",
      "dismissed": "Suggestion hidden",
      "showHidden": "Show hidden ({n})",
      "hideHidden": "Hide",
      "restore": "Restore",
      "restored": "Suggestion restored",
      "allDismissed": "All suggestions are hidden"
    },
    "searchExtendedPlaceholder": "Search name, category or notes…",
    "addToShopping": "Add to list",
    "selectMultiple": "Select",
    "selectAll": "All",
    "nSelected": "{n} selected",
    "bulkDeleted": "{n} items deleted",
    "noResults": "No matches for the current filters",
    "noExpiry": "No expiry date",
    "notes": "Notes",
    "notesPlaceholder": "e.g. organic, opened…",
    "foodScore": {
      "title": "Food Score",
      "subtitle": "Quality of your pantry",
      "info": {
        "title": "How the Food Score is calculated",
        "intro": "The score (0–100) rates how healthy and balanced your current pantry is. It is made of three weighted parts:",
        "catBody": "How many healthy categories you cover (vegetables, fruit, fish, legumes, whole grains, dairy …) and how high-quality the products are. Goal: at least 8 different healthy categories.",
        "medBody": "How well your pantry matches the Mediterranean diet: vegetables, fish, legumes and olive oil count positively — sweets and highly processed foods subtract.",
        "freshBody": "Based on expiry dates: expired items count 0, items expiring within 3 days count little, longer-lasting ones count fully. Without expiry dates this part counts as neutral (50).",
        "sparsity": "Note: with fewer than 5 products the score is reduced proportionally, so a nearly empty pantry can't rate as \"balanced\"."
      },
      "freshnessHint": "Tip: add expiry dates to your products to make the freshness score meaningful — without dates it counts as neutral (50).",
      "verdict": {
        "excellent": "Excellent pantry!",
        "balanced": "Well-balanced pantry.",
        "improvable": "You can improve variety.",
        "poor": "Add more vegetables and legumes.",
        "empty": "Add items to compute your score."
      },
      "sub": {
        "categories": "Variety",
        "mediterranean": "Mediterranean",
        "freshness": "Freshness"
      },
      "breakdown": {
        "vegetables": "Vegetables",
        "fruit": "Fruit",
        "fish": "Fish",
        "legumes": "Legumes",
        "grains": "Grains",
        "dairy": "Dairy",
        "meat": "Meat",
        "eggs": "Eggs"
      }
    }
  },
  "household": {
    "defaultName": "Our home",
    "sharedPantry": "Shared pantry",
    "emptyTitle": "Are you a family?",
    "emptyHint": "Share the pantry with whoever shops with you. Create a group or join with a code.",
    "createBtn": "Create group",
    "joinBtn": "Join",
    "inviteCode": "Invite code:",
    "leaveBtn": "Leave group",
    "leaveConfirmTitle": "Leave group?",
    "leaveConfirmText": "Shared items stay in the group. If you're the last member, the group is dissolved and the pantry becomes personal again.",
    "leaveConfirmBtn": "Leave",
    "codePlaceholder": "AB3D4E",
    "created": "Group created — share the invite code",
    "joined": "You joined the group",
    "left": "You left the group",
    "invalidCode": "Invalid invite code"
  },
  "pantryFeed": {
    "title": "Recent activity",
    "action": {
      "add": "added",
      "update": "updated",
      "delete": "removed",
      "deduct": "used",
      "used_up": "used up",
      "consumed": "marked as finished",
      "restored": "restored",
      "undo": "undid usage of"
    }
  },
  "clientLang": {
    "preferred": "Preferred language"
  },
  "clientHero": {
    "status": {
      "excellent": "Great progress",
      "good": "On track",
      "attention": "Needs attention",
      "unknown": "New client"
    },
    "coachAi": "Coach AI",
    "aiAnalysis": "AI Analysis",
    "aiError": "AI analysis failed",
    "copied": "Message copied",
    "sendAsFeedback": "Send as feedback",
    "today": "Today",
    "yesterday": "Yesterday",
    "weeklyAdherence": "Weekly adherence",
    "avg": "Avg:",
    "strengths": "Strengths",
    "toImprove": "To improve",
    "suggestedMessage": "Suggested message",
    "kpi": {
      "weight": "Weight",
      "calories": "Score",
      "protein": "Protein",
      "sleep": "Sleep",
      "hrv": "HRV",
      "steps": "Steps",
      "water": "Water",
      "workouts": "Workouts"
    },
    "trends": {
      "title": "Trends",
      "subtitle": "Last {days} days",
      "tabs": {
        "weight": "Weight",
        "sleep": "Sleep",
        "kcal": "Calories"
      },
      "avg": "Avg",
      "target": "Target",
      "empty": "No data in this period",
      "units": {
        "kg": "kg",
        "hours": "h",
        "kcal": "kcal"
      },
      "ranges": {
        "d7": "7d",
        "d14": "14d",
        "d30": "30d"
      }
    },
    "week": "wk"
  },
  "mealBadges": {
    "excellent": "Excellent meal",
    "highProtein": "High protein",
    "highFiber": "High fiber",
    "lightSnack": "Light snack",
    "lowProtein": "Low protein",
    "lowFiber": "Low veggies",
    "highSugar": "Too much sugar",
    "highSalt": "Too salty",
    "highSatFat": "Saturated fats",
    "heavySnack": "Heavy snack"
  },
  "mealFilter": {
    "all": "All",
    "problems": "Only problems",
    "warnings": "Needs attention",
    "counter": "{n} meals"
  },
  "adherence": {
    "title": "Adherence timeline",
    "subtitle": "Last {days} days",
    "avg": "Avg:",
    "empty": "No data"
  },
  "quickActions": {
    "chat": "Chat",
    "updatePlan": "Update plan",
    "writeFeedback": "Write feedback",
    "noMealToComment": "No meal without feedback"
  },
  "voiceFood": {
    "tap": "Search by voice",
    "listening": "Listening…",
    "processing": "Transcribing…",
    "tapToStop": "Tap to stop",
    "notSupported": "Your browser doesn't support the microphone",
    "micDenied": "Microphone permission denied",
    "tooShort": "Audio too short, try again",
    "notRecognized": "Couldn't catch that, try again",
    "error": "Transcription failed",
    "multiFound": "Found {n} foods",
    "multiHint": "Tap an item to search and log it",
    "tapToSearch": "Tap to search",
    "multiAllDone": "{n} foods logged ✓",
    "moveTo": "Move to {name}",
    "moved": "Moved to {name}"
  },
  "onboardingTutorial": {
    "skip": "Skip",
    "prev": "Back",
    "next": "Next",
    "start": "Get started",
    "loadError": "Couldn't load the tutorial",
    "profileButton": "Replay tutorial",
    "slides": {
      "welcome": {
        "hint": "50% veggies · 25% protein · 25% carbs",
        "title": "Your journey starts here",
        "body": "Welcome to Solano Essence. An elegant way to care for your body — one plate at a time."
      },
      "log": {
        "hint": "Voice · AI Photo · Search",
        "title": "Log in a heartbeat",
        "body": "Talk into the mic, snap a photo, or search our Solano database of 5,000+ foods."
      },
      "gamify": {
        "hint": "Streaks · Missions · Health states",
        "title": "Every good habit counts",
        "body": "Earn Solano Points for every healthy meal, workout and night of rest. Unlock badges and level up."
      },
      "sync": {
        "hint": "Automatic, quiet, always fresh",
        "title": "Sync your body",
        "body": "Connect Google Fit, Apple Health or your wearable. Steps, sleep and workouts always up to date."
      },
      "start": {
        "hint": "Log your first meal",
        "title": "You're ready",
        "body": "Your AI coach is by your side. Every small step counts — let's start together."
      }
    }
  },
  "rewards": {
    "navLabel": "Rewards",
    "title": "Your Rewards",
    "subtitle": "Consistency and wellness, one day at a time",
    "totalSp": "Solano Points",
    "levelLabel": "Level",
    "nextLevel": "Next State",
    "spToNext": "{n} SP to reach {name}",
    "maxLevel": "Max level reached",
    "streakCurrent": "Consecutive days",
    "streakLongest": "Personal best",
    "todaySp": "Earned today",
    "dailyMissions": "Today's missions",
    "dailyMissionsSub": "Complete all 3 for a {n} SP bonus",
    "allCompletedBonus": "Daily bonus unlocked! +{n} SP",
    "weeklyMissions": "Weekly missions",
    "weeklyMissionsSub": "Complete all 5 for a {n} SP bonus",
    "weeklyAllCompleted": "Weekly bonus unlocked! +{n} SP",
    "weeklyRange": "Week of {start} — {end}",
    "store": "Cosmetics store",
    "storeSub": "Available SP: {n}",
    "buy": "Buy",
    "purchased": "Purchased",
    "insufficientSp": "Not enough SP",
    "confirmPurchase": "Buy {name} for {cost} SP?",
    "purchaseSuccess": "🎉 Unlocked!",
    "spGained": "SP earned",
    "levelUpToast": "New level: {name}!",
    "levelUpTitle": "Level unlocked",
    "levelUpContinue": "Continue",
    "personalizeTitle": "Customize your profile",
    "personalizeHint": "Purchased cosmetics only",
    "personalizeThemes": "Active theme",
    "personalizeBadges": "Displayed badges (max 3)",
    "personalizeAnimations": "Animations",
    "themeDefault": "Petrol (default)",
    "categoryTheme": "Theme",
    "categoryBadge": "Exclusive badge",
    "categoryAnimation": "Animation",
    "itemNames": {
      "theme_forest": "Forest theme",
      "theme_ocean": "Ocean theme",
      "theme_sunset": "Sunset theme",
      "theme_bianconero": "Black & Gold",
      "theme_nerazzurro": "Blue & Black",
      "theme_rossonero": "Red & Black",
      "theme_azzurro": "Azure Italy",
      "theme_giallorosso": "Yellow & Red",
      "theme_tricolore": "Italy Tricolour",
      "theme_neon": "Neon Cyber",
      "theme_lavender": "Lavender Wellness",
      "theme_rosegold": "Rose Gold",
      "theme_matcha": "Matcha",
      "theme_midnight": "Midnight",
      "badge_early_bird": "Golden Sunrise",
      "badge_night_owl": "Night Owl",
      "badge_gourmet": "Gourmet",
      "anim_confetti_gold": "Gold confetti",
      "anim_progress_glow": "Progress glow",
      "anim_sparkle_rain": "Star rain",
      "anim_aura_pulse": "Aura pulse",
      "anim_shimmer": "Shimmer",
      "theme_summer": "Summer turquoise",
      "theme_halloween": "Halloween pumpkin",
      "theme_christmas": "Christmas red"
    },
    "itemDesc": {
      "default_theme": "Applies this palette to the level hero, progress bars and main gradients across the app.",
      "default_badge": "An exclusive badge shown on your profile.",
      "default_animation": "An animated effect that brings your wins to life.",
      "theme_forest": "Deep forest green with a fresh leaf accent — calm and natural.",
      "theme_ocean": "Deep ocean blues with a turquoise wave accent.",
      "theme_sunset": "Warm sunset from orange through pink to violet.",
      "theme_bianconero": "Classic black & white with a silver accent — elegant and timeless.",
      "theme_nerazzurro": "Night blue and black with an ice-blue accent.",
      "theme_rossonero": "Powerful red & black with a golden accent.",
      "theme_azzurro": "Bright azure with a light sky accent.",
      "theme_giallorosso": "Warm yellow-red in a rich gradient with a gold accent.",
      "anim_sparkle_rain": "Sparkling stars gently rain over your progress card.",
      "anim_confetti_gold": "Golden confetti rains over your screen on every level-up.",
      "anim_progress_glow": "Your progress bar pulses with a gentle glow.",
      "anim_aura_pulse": "A pulsing aura surrounds your level symbol.",
      "anim_shimmer": "An elegant light reflection sweeps across your progress card.",
      "theme_summer": "Lagoon turquoise with sun yellow — limited summer design, only available June to August.",
      "theme_halloween": "Pumpkin orange glowing out of a purple night sky — limited, only available around Halloween. 🎃",
      "theme_christmas": "Festive Christmas red with fir green and gold — limited, only available during Advent.",
      "theme_tricolore": "Italian flag: green-white-red in a clean gradient with emerald accent.",
      "theme_neon": "Cyberpunk vibes: deep violet, magenta and electric blue. Futuristic look.",
      "theme_lavender": "Lavender and plum tones for a calm, relaxing feel.",
      "theme_rosegold": "Elegant rose gold with champagne accent. Chic and refined.",
      "theme_matcha": "Matcha green with cream accent. Inspired by the Japanese tea ceremony.",
      "theme_midnight": "Deep midnight blue with starlight accent. Perfect for evening use."
    },
    "previewLabel": "Theme preview",
    "seasonalTag": "Limited",
    "seasonalLocked": "Seasonal design — only available {window}",
    "weeklyNames": {
      "wk_workouts_5": "5 workouts",
      "wk_plates_5": "5 excellent plates",
      "wk_sleep_6": "6 nights above 7h",
      "wk_fiber_5": "5 days with 30g fiber",
      "wk_steps_60k": "60,000 steps"
    },
    "syncFit": "Sync Google Fit",
    "syncFitHint": "No steps today — tap to sync",
    "syncing": "Syncing…",
    "syncOk": "Data synced",
    "syncFailed": "Sync failed",
    "badges": "Badges",
    "earnedBadges": "{n} unlocked",
    "lockedBadges": "{n} to unlock",
    "recentActivity": "Recent activity",
    "empty": "No events yet",
    "widgetTitle": "Progress",
    "widgetCta": "Open Rewards",
    "viewAll": "See all",
    "congratsBadge": "New badge unlocked!",
    "levelUp": "You reached a new state!",
    "states": {
      "newStart": {
        "name": "New Beginning",
        "quote": "Every great change starts with a small step."
      },
      "inBalance": {
        "name": "In Balance",
        "quote": "You are building healthy habits."
      },
      "activeWellness": {
        "name": "Active Wellness",
        "quote": "Your lifestyle is improving."
      },
      "steadyShape": {
        "name": "Steady Shape",
        "quote": "Consistency is your superpower."
      },
      "totalEnergy": {
        "name": "Total Energy",
        "quote": "Your body is thanking you."
      },
      "eliteHealth": {
        "name": "Elite Health",
        "quote": "You reached a higher wellness level."
      },
      "ambassador": {
        "name": "Ambassador",
        "quote": "You are a model of consistency and discipline."
      },
      "legend": {
        "name": "Legend",
        "quote": "Excellence has become your lifestyle."
      },
      "master": {
        "name": "Master",
        "quote": "You rule your habits – not the other way around."
      },
      "champion": {
        "name": "Champion",
        "quote": "Consistency at the highest level."
      },
      "inspiration": {
        "name": "Inspiration",
        "quote": "Your journey motivates others."
      },
      "diamond": {
        "name": "Diamond",
        "quote": "Forged under pressure, unbreakable."
      },
      "titan": {
        "name": "Titan",
        "quote": "Your discipline knows no limits."
      },
      "olymp": {
        "name": "Olympus",
        "quote": "You're playing in a league of your own."
      },
      "immortal": {
        "name": "Immortal",
        "quote": "Your habits are built to last forever."
      }
    },
    "badgeNames": {
      "meals_30": "30 meals logged",
      "meals_100": "100 meals logged",
      "water_100_days": "100 hydrated days",
      "steps_100k": "100k steps",
      "steps_1m": "1 million steps",
      "workouts_50": "50 workouts",
      "workouts_100": "100 workouts",
      "sleep_30": "30 nights of 7h",
      "streak_30": "30-day streak",
      "streak_100": "100-day streak",
      "first_month": "First month",
      "first_year": "First year",
      "protein_30": "30 days protein OK",
      "fiber_30": "30 days fiber OK",
      "learn_streak_7": "7-day learning streak",
      "learn_streak_30": "30-day learning streak",
      "learn_correct_50": "50 correct quiz answers"
    },
    "missionNames": {
      "protein_meal25": {
        "title": "Smart protein at a meal",
        "hint": "Hit at least 25 g of protein at one main meal."
      },
      "protein_daily": {
        "title": "Daily protein target",
        "hint": "Reach your personal daily protein goal."
      },
      "veg_2p": {
        "title": "Vegetables ×2",
        "hint": "Log two portions of vegetables today."
      },
      "fruit_2p": {
        "title": "Fruit ×2",
        "hint": "Log two portions of fruit today."
      },
      "fiber_target": {
        "title": "Fiber goal",
        "hint": "Reach your daily fiber target."
      },
      "plate_balanced": {
        "title": "Solano plate",
        "hint": "Balanced: 50% veggies, 25% protein, 25% carbs."
      },
      "steps_target": {
        "title": "Reach step goal",
        "hint": "Hit your personal daily steps target."
      },
      "active_min_20": {
        "title": "20 active minutes",
        "hint": "At least 20 min of moderate movement today."
      },
      "workout_done": {
        "title": "Complete workout",
        "hint": "Finish your planned session for today."
      },
      "rest_day_walk": {
        "title": "Recovery walk",
        "hint": "Rest day? Do at least 3,000 easy steps."
      },
      "water_target": {
        "title": "Water goal",
        "hint": "Reach your daily hydration target."
      },
      "log_all_meals": {
        "title": "Log every meal",
        "hint": "Breakfast, lunch and dinner — all 3."
      },
      "day_checkin": {
        "title": "Daily check-in",
        "hint": "Complete today's check-in."
      },
      "sleep_logged": {
        "title": "Log your sleep",
        "hint": "Enter last night's sleep duration."
      },
      "protein_bkfst30": {
        "title": "30g protein at breakfast",
        "hint": "Add eggs, Greek yogurt or whey to your first meal."
      },
      "water_2l": {
        "title": "Drink 2 liters of water",
        "hint": "One glass every hour keeps you on pace."
      },
      "steps_8k": {
        "title": "8,000 steps",
        "hint": "A 30-minute walk plus the stairs."
      },
      "fiber_30g": {
        "title": "30g of fiber",
        "hint": "Veggies at lunch/dinner + fruit and legumes."
      },
      "sleep_7h": {
        "title": "7h of sleep",
        "hint": "Turn off screens 30 min before bed."
      }
    },
    "swap": "Swap",
    "swapDone": "Mission swapped",
    "swapTooltip": "Swap this mission for another in the same category",
    "swapUsedTooltip": "You've already used today's swap",
    "actions": {
      "meal_log": "Meal logged",
      "meal_photo_bonus": "Meal photo",
      "plate_check_80": "Balanced plate check (80%+)",
      "plate_balanced": "Balanced plate",
      "water_goal": "Water goal",
      "steps_goal": "Steps goal",
      "workout_done": "Workout",
      "sleep_7h": "7h+ night",
      "learn_pill": "Tip read",
      "diary_complete": "Diary complete",
      "streak_bonus": "Streak bonus",
      "daily_bonus": "Missions bonus",
      "weekly_bonus": "Weekly bonus",
      "purchase": "Store purchase"
    }
  },
  "cook": {
    "title": "What shall I cook?",
    "subtitle": "{n} ideas from your pantry",
    "haveAll": "Everything on hand",
    "oneMissing": "1 ingredient missing",
    "manyMissing": "Several ingredients missing",
    "missing": "{n} missing",
    "addMissing": "Add to list",
    "addedToList": "{n} added to list",
    "cook": "Cook it"
  },
  "shopping": {
    "title": "Shopping list",
    "empty": "List is empty",
    "emptyHint": "Add anything you need, or wait for pantry items to run out.",
    "itemsCount": "{n} items to buy",
    "section": {
      "auto": "To restock",
      "manual": "You added"
    },
    "reason": {
      "consumed": "Used up",
      "expired": "Expired",
      "weeklyMenu": "From weekly menu",
      "shoppingCheck": "From Shopping Check"
    },
    "restockHint": "Buy: {qty} · lasts ~{days}d",
    "addPlaceholder": "Add an item (e.g. Milk)…",
    "boughtBtn": "Bought",
    "checkedByScan": "Ticked off",
    "movedToPantry": "{name} → added to your pantry",
    "expiry": {
      "title": "{name} bought",
      "body": "Best before? Optional – keeps your pantry freshness score accurate.",
      "d3": "+3 days",
      "w1": "+1 week",
      "w2": "+2 weeks",
      "m1": "+1 month",
      "until": "Best before {date}",
      "skip": "No date",
      "save": "To pantry"
    },
    "uncheckBtn": "Back on the list",
    "notNeededBtn": "Not needed",
    "shareBtn": "Share list",
    "copied": "List copied to clipboard",
    "restocked": "{name} back in pantry",
    "importAll": "Move all to pantry",
    "importedAdded": "{n} new",
    "importedMerged": "{n} updated",
    "importedRestocked": "{n} restocked",
    "importedNothing": "Nothing to import",
    "addedToList": "Added to shopping list"
  },
  "weekly": {
    "title": "Weekly Menu",
    "servings": "Serv.",
    "subtitle": "7 days balanced on your goals",
    "generate": "Generate menu",
    "regenerate": "Regenerate",
    "generated": "Menu generated!",
    "generatedWithList": "Menu ready! Missing ingredients added to your shopping list.",
    "viewShoppingList": "View list",
    "autoSyncedHint": "Ingredients you don't have in your pantry were auto-added to your shopping list.",
    "generatedAt": "Generated",
    "emptyHint": "You don't have a menu yet. Tap 'Generate menu' to create one tailored to you.",
    "shoppingList": "Shopping list",
    "addToPantry": "Add to pantry",
    "importedShopping": "Shopping added to pantry",
    "tapToBuy": "Tap an item to mark it bought and save it to the pantry",
    "movedToPantry": "Moved to pantry",
    "print": "Print",
    "printMenu": "Print menu",
    "printMenuShort": "Menu",
    "share": "Share",
    "copied": "Shopping list copied to clipboard",
    "allBought": "All bought!",
    "popupBlocked": "Pop-up blocked — enable pop-ups to print",
    "focusMode": "Shopping mode",
    "focusModeShort": "Shop",
    "showDone": "Show done",
    "hideDone": "Hide done",
    "voiceStart": "Check with voice",
    "voiceStop": "Stop listening",
    "voiceListening": "Listening…",
    "voiceNoMatch": "Couldn't match",
    "voiceError": "Microphone error",
    "voiceUnsupported": "Your browser doesn't support speech recognition",
    "mealLoading": "Preparing full recipe…",
    "ingredients": "Ingredients",
    "procedure": "Method",
    "fiber": "Fiber"
  },
  "shoppingAisle": {
    "produce": "Fruit & veg",
    "meatFish": "Meat & fish",
    "dairyEggs": "Dairy & eggs",
    "bakery": "Bakery",
    "pantry": "Pantry (dry)",
    "frozen": "Frozen",
    "supplements": "Proteins & Supplements",
    "beverages": "Beverages",
    "other": "Other"
  },
  "wearables": {
    "empty": "No wearable data yet. Connect a device to see Recovery, HRV, Sleep and more.",
    "sleep": "Sleep",
    "hrv": "HRV",
    "restingHr": "Resting HR",
    "strain": "Strain",
    "sleepChart": "Sleep (hours/night)",
    "hrvChart": "HRV (ms)",
    "syncNow": "Sync now",
    "syncing": "Syncing…",
    "syncOk": "Updated {n} days",
    "syncEmpty": "No new data",
    "lastSync": "Last sync:",
    "neverSynced": "Never synced",
    "title": "Wearable & Health",
    "connectDevice": "Connect a device",
    "deviceConnected": "{n} device connected",
    "devicesConnected": "{n} devices connected",
    "supportedList": "WHOOP · Garmin · Fitbit · Oura · Polar · Withings · Google Fit · Peloton · Apple Health",
    "tapToConnect": "Tap Add to connect a wearable and sync sleep, HRV and activity",
    "connectBtn": "Connect",
    "addBtn": "Add",
    "sdkError": "SDK not loaded — will open in a new page instead",
    "providerConnected": "{p} connected",
    "deviceConnectedToast": "Device connected",
    "connectWhoopDirect": "Connect WHOOP directly",
    "noDataYet": "No data yet",
    "agingToast": "{p} hasn't sent data for over 1 hour — sync to refresh",
    "autoSyncing": "Auto-syncing…",
    "autoSyncFailed": "Auto-sync for {p} failed",
    "rel": {
      "sec": "{n}s ago",
      "min": "{n}m ago",
      "hr": "{n}h ago",
      "day": "{n}d ago"
    }
  },
  "streaks": {
    "title": "Streak",
    "diary": "Diary",
    "weight": "Weight",
    "water": "Water",
    "daysShort": "d",
    "memberSince": "Member since",
    "activeDays": "active days",
    "keepItUp": "Keep going!",
    "badgeUnlockOne": "In 1 day you unlock the {name} Badge",
    "badgeUnlockMany": "In {n} days you unlock the {name} Badge",
    "badge_seed": "Seedling",
    "badge_bronze": "Bronze",
    "badge_silver": "Silver",
    "badge_gold": "Gold",
    "badge_diamond": "Diamond",
    "badge_legend": "Legend"
  },
  "chat": {
    "title": "Chat",
    "subtitleClient": "Message your nutritionist",
    "subtitleNut": "Reply to your clients",
    "noClients": "No clients yet",
    "noMessages": "No messages yet. Send the first one!",
    "linkNutFirst": "Link a nutritionist to start chatting",
    "selectClient": "Select a client",
    "messagePh": "Type a message…"
  },
  "progressPhotos": {
    "title": "Progress photos",
    "subtitle": "Front, side, back — compare over time",
    "front": "Front",
    "side": "Side",
    "back": "Back",
    "photoBtn": "Photo",
    "empty": "No photos yet.",
    "emptyHint": "Tap to add your first photo",
    "saved": "Photo saved",
    "latest": "Latest photos",
    "timeline": "Timeline",
    "compare": "Compare",
    "openCompare": "Compare selected",
    "compareTitle": "Comparison"
  },
  "igImport": {
    "title": "Import from Instagram",
    "subtitle": "Paste one of your post captions — AI creates the recipe with USDA/CREA macros.",
    "urlLabel": "Post link (optional)",
    "urlHint": "Useful to trace the source later.",
    "captionLabel": "Post caption",
    "captionPh": "Paste the Instagram caption here (emojis and hashtags included)…",
    "captionHint": "Optional if you upload a photo (e.g. a recipe infographic) – the AI reads the recipe straight from the image.",
    "photoLabel": "Dish photo (optional)",
    "photoPick": "Drag or tap to pick a photo",
    "photoOptional": "Recommended: helps AI understand the dish",
    "analyzeBtn": "Analyse with AI",
    "analyzing": "AI is reading your recipe…",
    "analyzingHint": "We extract name, ingredients, method and recompute macros from the Solano database.",
    "back": "Edit text",
    "cancel": "Cancel",
    "saveBtn": "Save recipe (public)",
    "saved": "Recipe imported and published",
    "fName": "Recipe name",
    "fMealType": "Meal type",
    "fServings": "Servings",
    "fDesc": "Description",
    "fIngredients": "Ingredients",
    "fInstructions": "Instructions",
    "ingHint": "One per line, with quantity and unit (e.g. 80g pasta, 1 egg)",
    "macrosPreview": "Macros per serving",
    "macrosComputed": "Computed from the food database",
    "perServing": "serving",
    "errImageOnly": "You can only upload images",
    "errTooBig": "Image too large, try a smaller one",
    "errCaptionShort": "The caption is too short",
    "errNeedInput": "Paste the text OR upload a recipe photo",
    "errAnalyze": "Analysis failed. Please retry."
  },
  "recipeEdit": {
    "tapToEdit": "Tap an ingredient to edit",
    "title": "Edit recipe",
    "editAll": "Edit recipe",
    "name": "Title",
    "description": "Description",
    "mealType": "Meal",
    "servings": "Servings",
    "prep": "Prep (min)",
    "cook": "Cook (min)",
    "difficulty": "Difficulty",
    "diff_easy": "Easy",
    "diff_medium": "Medium",
    "diff_hard": "Advanced",
    "onePerLine": "one per line",
    "tags": "Tags (comma separated)",
    "nutritionHint": "Nutrition is recalculated automatically from ingredients and servings.",
    "saved": "Recipe saved",
    "nameRequired": "Please enter a title",
    "ingredientsRequired": "At least one ingredient is required",
  },
  "recipes": {
    "qrScanBtn": "Scan QR",
    "qrScanTitle": "Scan QR code",
    "qrScanHint": "Point the camera at a friend's QR code (recipe or meal)",
    "qrInvalid": "Not a valid Solano QR code",
    "qrCameraError": "Camera unavailable. Please allow camera access.",
    "quickActionQr": "QR code",
    "qrTitle": "Share via QR code",
    "qrHint": "Scanning opens the recipe directly — in the app if it is installed.",
    "qrCopyLink": "Copy link",
    "goalScore": {
      "title": "Goal score",
      "goals": {
        "dimagrimento": "Weight loss",
        "mantenimento": "Maintain",
        "massa": "Muscle gain"
      },
      "bands": {
        "very_good": "Very well suited",
        "good": "Well suited",
        "conditional": "Partially suited",
        "less_suited": "Less suited"
      },
      "reasons": {
        "protein_rich": "High in protein",
        "satiating": "Filling at moderate calories",
        "fiber_rich": "Rich in fibre",
        "veg_rich": "High veggie/fruit share",
        "kcal_fits": "Calories fit this meal",
        "good_for_muscle": "Great meal for muscle gain",
        "kcal_high_for_goal": "A bit calorie-heavy for your goal",
        "kcal_low_for_goal": "A bit low in calories for bulking",
        "salt_high": "Relatively high in salt",
        "sugar_high": "Relatively high in sugar",
        "satfat_high": "High in saturated fat",
        "protein_low": "Low in protein",
        "over_budget_today": "Exceeds today's remaining budget",
        "balanced_ok": "Overall balanced"
      }
    },
    "nutritionBasisLabel": "Nutrition per serving",
    "nutritionBasisScaled": "Nutrition for {n} servings",
    "seasoningEstimateHint": "Spices/salt \"to taste\" and optional ingredients are not calculated exactly",
    "partialEstimateBadge": "Nutrition partially estimated",
    "highSaltWarning": "High salt content",
    "matchedCount": "{a} of {b} ingredients fully calculated",
    "reviewNeeded": "Nutrition incomplete — please check the ingredients",
    "reviewUnmatched": "Not recognised",
    "fixBtn": "Check & fix ingredients",
    "editIngredients": "Edit",
    "fillAmounts": "Fill in amounts",
    "fillAmountsHint": "Some ingredients have no amount – fill them with typical amounts & nutrition from the database.",
    "fillAmountsDone": "{n} ingredient(s) filled with typical amounts – please check",
    "fillAmountsNone": "All ingredients already have an amount",
    "livePerServing": "per serving",
    "liveTotal": "total",
    "liveCalculating": "Calculating…",
    "fixTitle": "Fix ingredients",
    "fixSubtitle": "Edit the ingredients until all are recognised. On save, nutrition values are recalculated automatically.",
    "fixMatched": "Recognised",
    "fixUnmatched": "Not recognised — edit the text or pick a food from the database via the magnifier",
    "fixNegligible": "Negligible (water/spice)",
    "fixPickFood": "Pick from database",
    "fixSearchPlaceholder": "Search food…",
    "fixNoResults": "No results",
    "fixSuggestion": "Did you mean",
    "fixAdd": "Add ingredient",
    "fixSearchDb": "Find match",
    "fixUnknownCount": "{n} ingredient(s) not recognised – highlighted, tap to pick a database match",
    "fixServings": "Servings",
    "fixSave": "Save & recalculate",
    "fixSaving": "Calculating…",
    "fixSavedOk": "Recipe updated — nutrition recalculated",
    "fixSavedStillReview": "Saved — some ingredients are still not recognised",
    "fixError": "Update failed",
    "cuisineTitle": "Wish cuisines (optional)",
    "cuisineNames": {
      "asian": "Asian",
      "mediterranean": "Mediterranean",
      "oriental": "Middle Eastern",
      "mexican": "Mexican",
      "indian": "Indian",
      "japanese": "Japanese",
      "thai": "Thai",
      "southamerican": "South American"
    },
    "title": "Recipes",
    "subtitle": "Save your favourite recipes with calories and macros",
    "newRecipe": "New recipe",
    "importInstagram": "From Instagram",
    "photoGenerate": "Generate AI photo",
    "photoRegenerate": "Regenerate AI photo",
    "photoGenerating": "Generating photo…",
    "photoGenerated": "Photo generated",
    "photoBatchStart": "Generate AI photos ({n} missing)",
    "photoBatchRunning": "Generating {done}/{total}…",
    "photoBatchDone": "{n} photos generated 🎉",
    "trBanner": "{n} recipes not yet in your language",
    "trBatchBtn": "Translate all",
    "trBatchRunning": "Translating {done}/{total}…",
    "trBatchDone": "{n} recipes translated 🎉",
    "saveRecipe": "Save recipe",
    "addBtn": "Add",
    "libraryBadge": "Library",
    "addToDiary": "Add to diary",
    "byAuthor": "by",
    "confirmDeleteOther": "Delete another user's recipe? This action is irreversible.",
    "deleted": "Recipe deleted",
    "more": "more…",
    "microSugar": "Sugar",
    "microFiber": "Fiber",
    "microSat": "Sat.",
    "microSalt": "Salt",
    "folderAll": "All",
    "folderFavorites": "Favorites",
    "folderBreakfast": "Breakfast",
    "folderSnack": "Snack",
    "folderLunch": "Lunch",
    "folderAfternoon": "Afternoon",
    "folderDinner": "Dinner",
    "folderSauce": "Sauce / Dressing",
    "collectionsTitle": "Collections",
    "collectionsNew": "New",
    "collectionsCreateTitle": "New collection",
    "collectionsEditTitle": "Edit collection",
    "collectionsNamePh": "Name (e.g. Meal prep)",
    "collectionsEmojiLabel": "Icon",
    "collectionsColorLabel": "Color",
    "collectionsCreateBtn": "Create",
    "collectionsSaveBtn": "Save",
    "collectionsDeleteConfirm": "Delete this collection? Your recipes stay in the library.",
    "collectionsAddTo": "Add to collection",
    "collectionsAddToTitle": "Save to collections",
    "collectionsCreated": "Collection created",
    "collectionsDeleted": "Collection deleted",
    "sauceAiBtn": "Suggest sauces with AI",
    "sauceAiHint": "Matched to your recipes and pantry — low in salt, with exact amounts",
    "sauceAiDone": "3 new sauces/dressings created",
    "recipeSingular": "recipe",
    "recipePlural": "recipes",
    "emptyLibrary": "No recipes yet",
    "emptyFolder": "Nothing here yet",
    "emptyFolderHint": "Add a recipe to this folder or pick another one.",
    "emptyFavorites": "No favorites yet",
    "emptyFavoritesHint": "Tap the heart on any recipe to save it here for one-tap reuse.",
    "favoriteAdded": "Added to favorites",
    "favoriteRemoved": "Removed from favorites",
    "favoriteAdd": "Add to favorites",
    "favoriteRemove": "Remove from favorites",
    "ingredients": "Ingredients",
    "preparation": "Preparation",
    "person": "person",
    "people": "people",
    "servingsHint": "Change portions when adding to the diary",
    "portion": "portion",
    "logPreview": "Will be added to your diary",
    "logPreviewAdapted": "The adjusted kcal will be added to your diary",
    "servingsOfHint": "Out of {total} recipe servings (quantities already scaled)",
    "scaledForPeople": "Scaled for {n} people",
    "visibilityTitle": "Who can see this recipe",
    "visibilityPrivate": "Only me",
    "visibilityNutritionist": "My nutritionist",
    "visibilityPublic": "Everyone",
    "visibilityPrivateShort": "Private",
    "visibilityNutritionistShort": "Nutritionist",
    "visibilityHint": "Change it any time. Recipes shared with 'Everyone' join the app's public library.",
    "visibilityUpdated": "Visibility updated",
    "useAdjustHint": "Adjust grams if you ate different amounts",
    "useAdjustedNotice": "Calories will be recomputed from the adjusted ingredients",
    "aiGenerateBtn": "Generate 5 with AI",
    "aiGenerating": "Generating…",
    "aiGeneratedOk": "5 recipes generated with AI!",
    "aiError": "AI error",
    "aiPromptTitle": "Generate recipes with AI",
    "aiPromptDesc": "Describe what you'd like (optional). The AI will generate 5 recipes matching your request.",
    "aiPromptPlaceholder": "e.g. menu under 500 kcal, gluten-free, quick to prepare…",
    "aiPromptGenerate": "Generate 5 recipes",
    "aiChipUnder500": "under 500 kcal",
    "aiChipHighProtein": "high in protein",
    "aiChipVegetarian": "vegetarian",
    "aiChipGlutenFree": "gluten-free",
    "aiChipQuick": "ready in 15 min",
    "adaptBtn": "Adapt kcal",
    "adaptTitle": "Adapt the recipe",
    "adaptDesc": "Current recipe: {current} kcal per serving. Enter your target kcal and I'll scale the quantities.",
    "adaptTargetLabel": "Target kcal per serving",
    "adaptConfirm": "Adapt",
    "adapting": "Adapting…",
    "adaptedOk": "Recipe adapted",
    "adaptError": "Could not adapt",
    "adaptInvalidKcal": "Enter a valid kcal value",
    "restoreOriginal": "Restore original",
    "verifiedBadge": "Verified nutrition values",
    "infographicBtn": "Recipe",
    "infographicBusy": "Creating…",
    "infographicDone": "Infographic saved!",
    "infographicServings": "servings",
    "infographicNutrition": "Nutrition per serving",
    "infographicIngredients": "Main ingredients",
    "infographicSteps": "Preparation",
    "recipeMenuShare": "Share",
    "recipeMenuDuplicate": "Duplicate recipe",
    "recipeMenuDelete": "Delete",
    "showAllIngredients": "Show all ingredients",
    "linkCopied": "Link copied",
    "difficultyEasy": "Easy",
    "difficultyMedium": "Medium",
    "difficultyHard": "Hard",
    "quickActionShare": "Share",
    "shareMenuLink": "Share link",
    "shareMenuLinkHint": "WhatsApp, Messages, email …",
    "shareMenuSocial": "Share to social media",
    "shareMenuSocialShort": "Social",
    "shareMenuSocialHint": "Image + caption for Instagram, TikTok & more",
    "socialShareTitle": "Share to social media",
    "socialFormatSquare": "Square 1:1",
    "socialFormatStory": "Story 9:16",
    "socialFormatPortrait": "Post 4:5",
    "socialFormatHintPortrait": "Post: choose “Post” in the Instagram share sheet – 4:5 fits without cropping.",
    "socialFullRecipeInApp": "Full recipe only in the app",
    "socialCaption": "AI caption",
    "socialCaptionBusy": "Writing caption …",
    "socialCaptionError": "Could not create caption",
    "socialCaptionHint": "Instagram & TikTok don't accept text automatically – it's copied to your clipboard when sharing, just paste it.",
    "socialCaptionInClipboard": "Caption copied – paste it in the app",
    "socialRegenerate": "New",
    "socialCopy": "Copy",
    "socialCopied": "Caption copied",
    "socialShareBtn": "Share image",
    "socialBusy": "Creating image …",
    "socialDownloaded": "Image saved",
    "socialMadeWith": "Made with Solano Essence",
    "socialPhotoFailed": "Recipe photo could not be embedded – card created without photo.",
    "socialFormatHintStory": "Story/Reel: choose “Story” in the Instagram share sheet – 9:16 fits without cropping.",
    "socialFormatHintSquare": "Square: long-press the image → save to Photos → post as a feed post in Instagram.",
    "socialLongPressHint": "Tip: long-press the image to save it to Photos.",
    "socialShareFailedHint": "Sharing not possible – long-press the image to save it.",
    "quickActionShoppingList": "Shopping list",
    "quickActionDuplicate": "Duplicate",
    "addedToShoppingList": "Ingredients added to list",
    "privacyPrivateDesc": "Only visible to you.",
    "privacyNutritionistDesc": "Shared with your clients.",
    "privacyPublicDesc": "Visible to the whole Solano community.",
    "addedToDiaryFlash": "Added to diary",
    "healthScoreTitle": "Health Score",
    "healthScoreGreat": "Very balanced",
    "healthScoreGood": "Balanced",
    "healthScoreImprove": "Reconsider",
    "goalFitTitle": "Fits for",
    "goalWeightLoss": "Weight loss",
    "goalMaintenance": "Maintenance",
    "goalMuscleGain": "Muscle gain",
    "aiCoachBtn": "AI Coach",
    "aiCoachTitle": "Modify recipe with AI",
    "aiCoachDesc": "Describe how you'd like to modify the recipe. The AI will generate a new version with updated ingredients, steps and macros.",
    "aiCoachPlaceholder": "e.g. make it vegetarian / +protein / no lactose / 700 kcal / for 4 people",
    "aiCoachRun": "Generate with AI",
    "aiCoachRunning": "AI is working…",
    "aiCoachDone": "Recipe modified by AI",
    "aiCoachError": "The AI couldn't modify the recipe",
    "aiCoachBadge": "AI modified",
    "aiCoachRestore": "Restore original",
    "aiCoachChipVeggie": "Vegetarian",
    "aiCoachChipHiPro": "More protein",
    "aiCoachChipNoLactose": "No lactose",
    "aiCoachChipKcal": "700 kcal",
    "aiCoachChipServings": "For 4",
    "aiCoachChipCheap": "Cheaper",
    "aiEstimateBadge": "Estimated nutrition",
    "goalPortionDependent": "depends on portion & daily balance",
    "recomputeBtn": "Recompute",
    "recomputing": "Recomputing…",
    "recomputedOk": "Macros recomputed",
    "recomputeError": "Could not recompute",
    "formName": "Name",
    "formDescription": "Description",
    "formIngredients": "Ingredients (one per line)",
    "formIngredientsPh": "80g pasta\n1 tbsp olive oil\n...",
    "formServings": "Servings",
    "formPrepMin": "Prep. (min)",
    "formKcalServing": "Kcal/serving",
    "formMealType": "Meal type",
    "formProtein": "P (g)",
    "formCarbs": "C (g)",
    "formFat": "F (g)",
    "formDate": "Date",
    "nameRequired": "Recipe name is required",
    "recipeSaved": "Recipe saved",
    "addedToDiary": "Added to diary!",
    "shareExpired": "The link has expired.",
    "shareNotFound": "Shared recipe not found."
  },
  "groupChallenges": {
    "section": "Group challenges",
    "new": "New",
    "auto": "AUTO",
    "manual": "MANUAL",
    "autoTip": "Automatically verified from your app data",
    "manualTip": "Manual check-in (trust-based)",
    "daysRemaining": "{n} days left",
    "lastDay": "Last day!",
    "today": "Today",
    "yourProgress": "Your progress",
    "daysUnit": "days",
    "wearableHint": "Connect your smartwatch (Vital.io) for automatic verification",
    "targetReached": "Target reached today",
    "needMore": "{n} {unit} to go",
    "markDone": "Mark today as done",
    "doneToday": "Done today",
    "noOneCheckedIn": "No one has checked in yet",
    "leaderInFront": "leading",
    "newTitle": "New group challenge",
    "newDesc": "Pick a goal, duration and friends to invite.",
    "chooseGoal": "Choose a goal",
    "customTitleLabel": "Custom challenge",
    "customHint": "Manual · trust-based check-in",
    "autoDisclaimer": "Challenges with an AUTO badge are verified automatically from your logged data (water, workouts, meals, smartwatch). Cheating isn't possible.",
    "fldTitle": "Title",
    "fldEmoji": "Emoji",
    "fldTargetPerDay": "Target/day",
    "fldUnit": "Unit",
    "titlePlaceholder": "e.g. Morning meditation",
    "unitPlaceholder": "e.g. minutes",
    "target": "Target",
    "duration": "Duration",
    "d7": "7 days",
    "d30": "30 days",
    "inviteFriends": "Invite friends",
    "selectedCount": "({n} selected)",
    "create": "Create challenge",
    "creating": "Creating…",
    "emptyTitle": "No active challenges",
    "emptyDesc": "Challenge your friends: 10k steps, 5 veggie portions, weekly workouts…",
    "emptyCta": "Create your first challenge",
    "inviteBadge": "Challenge invite",
    "inviteDetails": "{days} days · {n} already in",
    "accept": "Accept",
    "decline": "Decline",
    "detailSubtitle": "Leaderboard by days completed",
    "detailStats": "{d} days · {n} participants",
    "you": "You",
    "leave": "Leave challenge",
    "del": "Delete challenge",
    "confirmDelete": "Permanently delete this challenge for everyone?",
    "confirmLeave": "Do you want to leave this challenge?",
    "toastCreated": "Challenge created!",
    "toastCheckinDone": "Nice! Check-in recorded 🎯",
    "toastCheckinRemoved": "Check-in removed",
    "toastAccepted": "Challenge accepted!",
    "toastDeleted": "Challenge deleted",
    "toastLeft": "You left the challenge",
    "toastAutoNotYet": "Auto-verified challenge: {n} {unit} to go. Log the data in the app!",
    "toastError": "Error",
    "loading": "Loading challenges…"
  },
  "privacy": {
    "title": "Privacy & Legal",
    "exportPdf": "Export as PDF",
    "sections": {
      "privacy": "Privacy policy",
      "beta": "Important notice",
      "medical": "Medical notice",
      "consents": "Manage consents",
      "delete": "Delete account & data",
      "contact": "Contact / privacy request"
    }
  },
  "addMeal": {
    "addPhoto": "Add photo",
    "addPhotoSub": "Photograph your meal",
    "tbShare": "Share",
    "tbQr": "QR",
    "tbFav": "Favourite",
    "tbDuplicate": "Duplicate",
    "tbPhoto": "Photo",
    "tbClear": "Clear",
    "tbClose": "Close",
    "favoriteAdded": "Added to favourites",
    "favoriteRemoved": "Removed from favourites",
    "duplicated": "Meal duplicated",
    "duplicatePickTitle": "Duplicate a meal",
    "duplicatePickSubtitle": "Pick a recent meal to reuse",
    "duplicatePickEmpty": "No recent meals to duplicate",
    "quickLogTitle": "Quick log",
    "sauceTitle": "Add a sauce?",
    "quickLogSubtitle": "Log a favorite in one tap or duplicate a recent meal",
    "favTab": "Favorites",
    "recentTab": "Recent",
    "favPickEmpty": "No favorites yet — save a meal with the heart icon",
    "favTapToLog": "Tap to log",
    "favLogged": "“{name}” logged",
    "duplicateFromDiary": "Duplicate from diary",
    "shareTapToOpen": "Tap the link to open it in your Solano Essence app:",
    "sharedOk": "Recipe shared",
    "sharedCopied": "Link copied — paste into WhatsApp or anywhere",
    "imported": "Recipe imported from link",
    "shareExpired": "This link has expired (90-day validity)",
    "shareNotFound": "Recipe not found",
    "eatWhereTitle": "Where did you eat?",
    "eatHome": "At home",
    "eatOut": "Eating out",
    "eatHomeHint": "Matching ingredients are deducted from your pantry automatically.",
    "eatOutHint": "Eaten out — nothing is deducted from your pantry."
  },
  "features": {
    "title": "My features",
    "subtitle": "Choose which tools you want to see on your dashboard",
    "summary": "{on}/{total} on",
    "enabled": "Feature enabled",
    "disabled": "Feature disabled",
    "footnote": "You can change these settings anytime. Disabled features will stop showing widgets, reminders and notifications.",
    "items": {
      "water": {
        "label": "Daily water",
        "desc": "Track glasses and ml of water"
      },
      "weight": {
        "label": "Weight & waist",
        "desc": "Log body weight and measurements"
      },
      "sleep": {
        "label": "Sleep & HRV",
        "desc": "Sync sleep duration and heart-rate variability"
      },
      "steps_wearable": {
        "label": "Steps & wearable",
        "desc": "Daily steps from Apple Health / Fitbit / Garmin"
      },
      "workouts": {
        "label": "Workouts",
        "desc": "Log sessions and calories burned"
      },
      "supplements": {
        "label": "Supplements",
        "desc": "Reminders and check-ins for supplements"
      },
      "gamification": {
        "label": "Gamification",
        "desc": "Points, badges, levels and streaks"
      },
      "pantry": {
        "label": "Pantry",
        "desc": "Manage the ingredients you have at home"
      },
      "plate_solano": {
        "label": "Solano plate",
        "desc": "50/25/25 breakdown (veg/protein/carbs)"
      },
      "mediterranean_score": {
        "label": "Mediterranean score",
        "desc": "Mediterranean diet adherence"
      },
      "coach_ai": {
        "label": "AI coach",
        "desc": "Automatic AI suggestions and feedback"
      }
    }
  },
  "coach": {
    "title": "Today's coach",
    "today": "Solano AI",
    "refresh": "Refresh"
  }
};

export default en;
